/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AttributionsRouteImport } from './routes/attributions'
import { Route as LoginRouteImport } from './routes/login'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as MobileAppsRouteImport } from './routes/mobile-apps'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedProtectedRouteRouteImport } from './routes/_authenticated/_protected/route'
import { Route as AuthenticatedBannedRouteImport } from './routes/_authenticated/banned'
import { Route as AuthenticatedLockedRouteImport } from './routes/_authenticated/locked'
import { Route as AuthenticatedPendingDeletionRouteImport } from './routes/_authenticated/pending-deletion'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as OauthResumeRouteImport } from './routes/oauth/resume'
import { Route as TPublicShareIdRouteImport } from './routes/t/$publicShareId'
import { Route as AuthenticatedProtectedIndexRouteImport } from './routes/_authenticated/_protected/index'
import { Route as AuthenticatedProtectedAdminRouteRouteImport } from './routes/_authenticated/_protected/_admin/route'
import { Route as AuthenticatedProtectedAboutRouteImport } from './routes/_authenticated/_protected/about'
import { Route as AuthenticatedProtectedBiometricSetupRouteImport } from './routes/_authenticated/_protected/biometric-setup'
import { Route as AuthenticatedProtectedCopyrightRouteImport } from './routes/_authenticated/_protected/copyright'
import { Route as AuthenticatedProtectedCountriesRouteImport } from './routes/_authenticated/_protected/countries'
import { Route as AuthenticatedProtectedCountryCoversRouteImport } from './routes/_authenticated/_protected/country-covers'
import { Route as AuthenticatedProtectedCurrencyExchangeRouteImport } from './routes/_authenticated/_protected/currency-exchange'
import { Route as AuthenticatedProtectedDeleteAccountRouteImport } from './routes/_authenticated/_protected/delete-account'
import { Route as AuthenticatedProtectedDesignSystemRouteImport } from './routes/_authenticated/_protected/design-system'
import { Route as AuthenticatedProtectedDeveloperRouteImport } from './routes/_authenticated/_protected/developer'
import { Route as AuthenticatedProtectedForgotPasswordRouteImport } from './routes/_authenticated/_protected/forgot-password'
import { Route as AuthenticatedProtectedImageCreditsRouteImport } from './routes/_authenticated/_protected/image-credits'
import { Route as AuthenticatedProtectedImportEmailHelpRouteImport } from './routes/_authenticated/_protected/import-email-help'
import { Route as AuthenticatedProtectedLegalRouteImport } from './routes/_authenticated/_protected/legal'
import { Route as AuthenticatedProtectedMapRouteImport } from './routes/_authenticated/_protected/map'
import { Route as AuthenticatedProtectedMoreRouteImport } from './routes/_authenticated/_protected/more'
import { Route as AuthenticatedProtectedNotificationsRouteImport } from './routes/_authenticated/_protected/notifications'
import { Route as AuthenticatedProtectedOnboardingRouteImport } from './routes/_authenticated/_protected/onboarding'
import { Route as AuthenticatedProtectedOpenSourceRouteImport } from './routes/_authenticated/_protected/open-source'
import { Route as AuthenticatedProtectedPaywallRouteImport } from './routes/_authenticated/_protected/paywall'
import { Route as AuthenticatedProtectedPlansRouteImport } from './routes/_authenticated/_protected/plans'
import { Route as AuthenticatedProtectedProfileRouteImport } from './routes/_authenticated/_protected/profile'
import { Route as AuthenticatedProtectedResourcesRouteImport } from './routes/_authenticated/_protected/resources'
import { Route as AuthenticatedProtectedSearchRouteImport } from './routes/_authenticated/_protected/search'
import { Route as AuthenticatedProtectedShareIntentRouteImport } from './routes/_authenticated/_protected/share-intent'
import { Route as AuthenticatedProtectedStatisticsRouteImport } from './routes/_authenticated/_protected/statistics'
import { Route as AuthenticatedProtectedSupportRouteImport } from './routes/_authenticated/_protected/support'
import { Route as AuthenticatedProtectedTranslateRouteImport } from './routes/_authenticated/_protected/translate'
import { Route as AuthenticatedProtectedTravelBucketListRouteImport } from './routes/_authenticated/_protected/travel-bucket-list'
import { Route as AuthenticatedProtectedUsageRouteImport } from './routes/_authenticated/_protected/usage'
import { Route as AuthenticatedProtectedWelcomeRouteImport } from './routes/_authenticated/_protected/welcome'
import { Route as PackingListsSharedTokenRouteImport } from './routes/packing-lists/shared/$token'
import { Route as TripsInvitationsRespondRouteImport } from './routes/trips/invitations/respond'
import { Route as AuthenticatedProtectedAdminAdminRouteRouteImport } from './routes/_authenticated/_protected/_admin/admin/route'
import { Route as AuthenticatedProtectedCountryIdRouteImport } from './routes/_authenticated/_protected/country/$id'
import { Route as AuthenticatedProtectedDriveConnectedRouteImport } from './routes/_authenticated/_protected/drive/connected'
import { Route as AuthenticatedProtectedPackingListsIndexRouteImport } from './routes/_authenticated/_protected/packing-lists/index'
import { Route as AuthenticatedProtectedPackingListsNewRouteImport } from './routes/_authenticated/_protected/packing-lists/new'
import { Route as AuthenticatedProtectedSettingsIndexRouteImport } from './routes/_authenticated/_protected/settings/index'
import { Route as AuthenticatedProtectedSettingsConnectionsRouteImport } from './routes/_authenticated/_protected/settings/connections'
import { Route as AuthenticatedProtectedSettingsPasswordRouteImport } from './routes/_authenticated/_protected/settings/password'
import { Route as AuthenticatedProtectedSettingsPermissionsRouteImport } from './routes/_authenticated/_protected/settings/permissions'
import { Route as AuthenticatedProtectedSettingsPlansRouteImport } from './routes/_authenticated/_protected/settings/plans'
import { Route as AuthenticatedProtectedSettingsSubscriptionRouteImport } from './routes/_authenticated/_protected/settings/subscription'
import { Route as AuthenticatedProtectedTripTripIdRouteImport } from './routes/_authenticated/_protected/trip/$tripId'
import { Route as AuthenticatedProtectedTripsIndexRouteImport } from './routes/_authenticated/_protected/trips/index'
import { Route as AuthenticatedProtectedTripsNewRouteImport } from './routes/_authenticated/_protected/trips/new'
import { Route as AuthenticatedProtectedUsersUserIdRouteImport } from './routes/_authenticated/_protected/users/$userId'
import { Route as AuthenticatedProtectedAdminAdminAppStoreLinksRouteImport } from './routes/_authenticated/_protected/_admin/admin/app-store-links'
import { Route as AuthenticatedProtectedAdminAdminAttributionsRouteImport } from './routes/_authenticated/_protected/_admin/admin/attributions'
import { Route as AuthenticatedProtectedAdminAdminAuthenticationRouteImport } from './routes/_authenticated/_protected/_admin/admin/authentication'
import { Route as AuthenticatedProtectedAdminAdminGeneralRouteImport } from './routes/_authenticated/_protected/_admin/admin/general'
import { Route as AuthenticatedProtectedAdminAdminJobsRouteImport } from './routes/_authenticated/_protected/_admin/admin/jobs'
import { Route as AuthenticatedProtectedAdminAdminLegalRouteImport } from './routes/_authenticated/_protected/_admin/admin/legal'
import { Route as AuthenticatedProtectedAdminAdminMessagesRouteImport } from './routes/_authenticated/_protected/_admin/admin/messages'
import { Route as AuthenticatedProtectedAdminAdminPlansRouteImport } from './routes/_authenticated/_protected/_admin/admin/plans'
import { Route as AuthenticatedProtectedAdminAdminQueuesRouteImport } from './routes/_authenticated/_protected/_admin/admin/queues'
import { Route as AuthenticatedProtectedPackingListsIdIndexRouteImport } from './routes/_authenticated/_protected/packing-lists/$id/index'
import { Route as AuthenticatedProtectedPackingListsIdEditRouteImport } from './routes/_authenticated/_protected/packing-lists/$id/edit'
import { Route as AuthenticatedProtectedPackingListsIdInfoRouteImport } from './routes/_authenticated/_protected/packing-lists/$id/info'
import { Route as AuthenticatedProtectedPackingListsIdShareRouteImport } from './routes/_authenticated/_protected/packing-lists/$id/share'
import { Route as AuthenticatedProtectedTripsIdIndexRouteImport } from './routes/_authenticated/_protected/trips/$id/index'
import { Route as AuthenticatedProtectedTripsIdAttachmentsRouteImport } from './routes/_authenticated/_protected/trips/$id/attachments'
import { Route as AuthenticatedProtectedTripsIdDetailsRouteImport } from './routes/_authenticated/_protected/trips/$id/details'
import { Route as AuthenticatedProtectedTripsIdEditRouteImport } from './routes/_authenticated/_protected/trips/$id/edit'
import { Route as AuthenticatedProtectedTripsIdExportRouteImport } from './routes/_authenticated/_protected/trips/$id/export'
import { Route as AuthenticatedProtectedTripsIdImportActivityRouteImport } from './routes/_authenticated/_protected/trips/$id/import-activity'
import { Route as AuthenticatedProtectedTripsIdRoutesRouteImport } from './routes/_authenticated/_protected/trips/$id/routes'
import { Route as AuthenticatedProtectedTripsIdSearchRouteImport } from './routes/_authenticated/_protected/trips/$id/search'
import { Route as AuthenticatedProtectedTripsIdSummaryRouteImport } from './routes/_authenticated/_protected/trips/$id/summary'
import { Route as AuthenticatedProtectedTripsIdTravellersRouteImport } from './routes/_authenticated/_protected/trips/$id/travellers'
import { Route as AuthenticatedProtectedAdminAdminEmailTemplatesIndexRouteImport } from './routes/_authenticated/_protected/_admin/admin/email-templates/index'
import { Route as AuthenticatedProtectedAdminAdminEmailTemplatesKeyRouteImport } from './routes/_authenticated/_protected/_admin/admin/email-templates/$key'
import { Route as AuthenticatedProtectedAdminAdminUsersIndexRouteImport } from './routes/_authenticated/_protected/_admin/admin/users/index'
import { Route as AuthenticatedProtectedAdminAdminUsersNewRouteImport } from './routes/_authenticated/_protected/_admin/admin/users/new'
import { Route as AuthenticatedProtectedPackingListsIdBagsNewRouteImport } from './routes/_authenticated/_protected/packing-lists/$id/bags/new'
import { Route as AuthenticatedProtectedTripsIdCostsCostIdRouteImport } from './routes/_authenticated/_protected/trips/$id/costs/$costId'
import { Route as AuthenticatedProtectedTripsIdCostsAddRouteImport } from './routes/_authenticated/_protected/trips/$id/costs/add'
import { Route as AuthenticatedProtectedTripsIdFolderIndexRouteImport } from './routes/_authenticated/_protected/trips/$id/folder/index'
import { Route as AuthenticatedProtectedTripsIdFolderPickRouteImport } from './routes/_authenticated/_protected/trips/$id/folder/pick'
import { Route as AuthenticatedProtectedAdminAdminUsersIdIndexRouteImport } from './routes/_authenticated/_protected/_admin/admin/users/$id/index'
import { Route as AuthenticatedProtectedAdminAdminUsersIdEditRouteImport } from './routes/_authenticated/_protected/_admin/admin/users/$id/edit'
import { Route as AuthenticatedProtectedPackingListsIdBagsBagIdEditRouteImport } from './routes/_authenticated/_protected/packing-lists/$id/bags/$bagId/edit'
import { Route as AuthenticatedProtectedTripsIdEventsEventIdIndexRouteImport } from './routes/_authenticated/_protected/trips/$id/events/$eventId/index'
import { Route as AuthenticatedProtectedTripsIdEventsEventIdCostsRouteImport } from './routes/_authenticated/_protected/trips/$id/events/$eventId/costs'
import { Route as AuthenticatedProtectedTripsIdEventsEventIdEditRouteImport } from './routes/_authenticated/_protected/trips/$id/events/$eventId/edit'
import { Route as AuthenticatedProtectedTripsIdEventsEventIdInfoRouteImport } from './routes/_authenticated/_protected/trips/$id/events/$eventId/info'
import { Route as AuthenticatedProtectedTripsIdEventsAddIndexRouteImport } from './routes/_authenticated/_protected/trips/$id/events/add/index'
import { Route as AuthenticatedProtectedTripsIdEventsAddManualRouteImport } from './routes/_authenticated/_protected/trips/$id/events/add/manual'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AttributionsRoute = AttributionsRouteImport.update({
  id: '/attributions',
  path: '/attributions',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const McpRoute = McpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const MobileAppsRoute = MobileAppsRouteImport.update({
  id: '/mobile-apps',
  path: '/mobile-apps',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProtectedRouteRoute =
  AuthenticatedProtectedRouteRouteImport.update({
    id: '/_protected',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBannedRoute = AuthenticatedBannedRouteImport.update({
  id: '/banned',
  path: '/banned',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLockedRoute = AuthenticatedLockedRouteImport.update({
  id: '/locked',
  path: '/locked',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPendingDeletionRoute =
  AuthenticatedPendingDeletionRouteImport.update({
    id: '/pending-deletion',
    path: '/pending-deletion',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/auth/verify-email',
  path: '/auth/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthResumeRoute = OauthResumeRouteImport.update({
  id: '/oauth/resume',
  path: '/oauth/resume',
  getParentRoute: () => rootRouteImport,
} as any)
const TPublicShareIdRoute = TPublicShareIdRouteImport.update({
  id: '/t/$publicShareId',
  path: '/t/$publicShareId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProtectedIndexRoute =
  AuthenticatedProtectedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedAdminRouteRoute =
  AuthenticatedProtectedAdminRouteRouteImport.update({
    id: '/_admin',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedAboutRoute =
  AuthenticatedProtectedAboutRouteImport.update({
    id: '/about',
    path: '/about',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedBiometricSetupRoute =
  AuthenticatedProtectedBiometricSetupRouteImport.update({
    id: '/biometric-setup',
    path: '/biometric-setup',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedCopyrightRoute =
  AuthenticatedProtectedCopyrightRouteImport.update({
    id: '/copyright',
    path: '/copyright',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedCountriesRoute =
  AuthenticatedProtectedCountriesRouteImport.update({
    id: '/countries',
    path: '/countries',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedCountryCoversRoute =
  AuthenticatedProtectedCountryCoversRouteImport.update({
    id: '/country-covers',
    path: '/country-covers',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedCurrencyExchangeRoute =
  AuthenticatedProtectedCurrencyExchangeRouteImport.update({
    id: '/currency-exchange',
    path: '/currency-exchange',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedDeleteAccountRoute =
  AuthenticatedProtectedDeleteAccountRouteImport.update({
    id: '/delete-account',
    path: '/delete-account',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedDesignSystemRoute =
  AuthenticatedProtectedDesignSystemRouteImport.update({
    id: '/design-system',
    path: '/design-system',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedDeveloperRoute =
  AuthenticatedProtectedDeveloperRouteImport.update({
    id: '/developer',
    path: '/developer',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedForgotPasswordRoute =
  AuthenticatedProtectedForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedImageCreditsRoute =
  AuthenticatedProtectedImageCreditsRouteImport.update({
    id: '/image-credits',
    path: '/image-credits',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedImportEmailHelpRoute =
  AuthenticatedProtectedImportEmailHelpRouteImport.update({
    id: '/import-email-help',
    path: '/import-email-help',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedLegalRoute =
  AuthenticatedProtectedLegalRouteImport.update({
    id: '/legal',
    path: '/legal',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedMapRoute =
  AuthenticatedProtectedMapRouteImport.update({
    id: '/map',
    path: '/map',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedMoreRoute =
  AuthenticatedProtectedMoreRouteImport.update({
    id: '/more',
    path: '/more',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedNotificationsRoute =
  AuthenticatedProtectedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedOnboardingRoute =
  AuthenticatedProtectedOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedOpenSourceRoute =
  AuthenticatedProtectedOpenSourceRouteImport.update({
    id: '/open-source',
    path: '/open-source',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPaywallRoute =
  AuthenticatedProtectedPaywallRouteImport.update({
    id: '/paywall',
    path: '/paywall',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPlansRoute =
  AuthenticatedProtectedPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedProfileRoute =
  AuthenticatedProtectedProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedResourcesRoute =
  AuthenticatedProtectedResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSearchRoute =
  AuthenticatedProtectedSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedShareIntentRoute =
  AuthenticatedProtectedShareIntentRouteImport.update({
    id: '/share-intent',
    path: '/share-intent',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedStatisticsRoute =
  AuthenticatedProtectedStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSupportRoute =
  AuthenticatedProtectedSupportRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTranslateRoute =
  AuthenticatedProtectedTranslateRouteImport.update({
    id: '/translate',
    path: '/translate',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTravelBucketListRoute =
  AuthenticatedProtectedTravelBucketListRouteImport.update({
    id: '/travel-bucket-list',
    path: '/travel-bucket-list',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedUsageRoute =
  AuthenticatedProtectedUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedWelcomeRoute =
  AuthenticatedProtectedWelcomeRouteImport.update({
    id: '/welcome',
    path: '/welcome',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const PackingListsSharedTokenRoute = PackingListsSharedTokenRouteImport.update({
  id: '/packing-lists/shared/$token',
  path: '/packing-lists/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TripsInvitationsRespondRoute = TripsInvitationsRespondRouteImport.update({
  id: '/trips/invitations/respond',
  path: '/trips/invitations/respond',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProtectedAdminAdminRouteRoute =
  AuthenticatedProtectedAdminAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => AuthenticatedProtectedAdminRouteRoute,
  } as any)
const AuthenticatedProtectedCountryIdRoute =
  AuthenticatedProtectedCountryIdRouteImport.update({
    id: '/country/$id',
    path: '/country/$id',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedDriveConnectedRoute =
  AuthenticatedProtectedDriveConnectedRouteImport.update({
    id: '/drive/connected',
    path: '/drive/connected',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIndexRoute =
  AuthenticatedProtectedPackingListsIndexRouteImport.update({
    id: '/packing-lists/',
    path: '/packing-lists/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsNewRoute =
  AuthenticatedProtectedPackingListsNewRouteImport.update({
    id: '/packing-lists/new',
    path: '/packing-lists/new',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSettingsIndexRoute =
  AuthenticatedProtectedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSettingsConnectionsRoute =
  AuthenticatedProtectedSettingsConnectionsRouteImport.update({
    id: '/settings/connections',
    path: '/settings/connections',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSettingsPasswordRoute =
  AuthenticatedProtectedSettingsPasswordRouteImport.update({
    id: '/settings/password',
    path: '/settings/password',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSettingsPermissionsRoute =
  AuthenticatedProtectedSettingsPermissionsRouteImport.update({
    id: '/settings/permissions',
    path: '/settings/permissions',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSettingsPlansRoute =
  AuthenticatedProtectedSettingsPlansRouteImport.update({
    id: '/settings/plans',
    path: '/settings/plans',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedSettingsSubscriptionRoute =
  AuthenticatedProtectedSettingsSubscriptionRouteImport.update({
    id: '/settings/subscription',
    path: '/settings/subscription',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripTripIdRoute =
  AuthenticatedProtectedTripTripIdRouteImport.update({
    id: '/trip/$tripId',
    path: '/trip/$tripId',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIndexRoute =
  AuthenticatedProtectedTripsIndexRouteImport.update({
    id: '/trips/',
    path: '/trips/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsNewRoute =
  AuthenticatedProtectedTripsNewRouteImport.update({
    id: '/trips/new',
    path: '/trips/new',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedUsersUserIdRoute =
  AuthenticatedProtectedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminAppStoreLinksRoute =
  AuthenticatedProtectedAdminAdminAppStoreLinksRouteImport.update({
    id: '/app-store-links',
    path: '/app-store-links',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminAttributionsRoute =
  AuthenticatedProtectedAdminAdminAttributionsRouteImport.update({
    id: '/attributions',
    path: '/attributions',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminAuthenticationRoute =
  AuthenticatedProtectedAdminAdminAuthenticationRouteImport.update({
    id: '/authentication',
    path: '/authentication',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminGeneralRoute =
  AuthenticatedProtectedAdminAdminGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminJobsRoute =
  AuthenticatedProtectedAdminAdminJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminLegalRoute =
  AuthenticatedProtectedAdminAdminLegalRouteImport.update({
    id: '/legal',
    path: '/legal',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminMessagesRoute =
  AuthenticatedProtectedAdminAdminMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminPlansRoute =
  AuthenticatedProtectedAdminAdminPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminQueuesRoute =
  AuthenticatedProtectedAdminAdminQueuesRouteImport.update({
    id: '/queues',
    path: '/queues',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIdIndexRoute =
  AuthenticatedProtectedPackingListsIdIndexRouteImport.update({
    id: '/packing-lists/$id/',
    path: '/packing-lists/$id/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIdEditRoute =
  AuthenticatedProtectedPackingListsIdEditRouteImport.update({
    id: '/packing-lists/$id/edit',
    path: '/packing-lists/$id/edit',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIdInfoRoute =
  AuthenticatedProtectedPackingListsIdInfoRouteImport.update({
    id: '/packing-lists/$id/info',
    path: '/packing-lists/$id/info',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIdShareRoute =
  AuthenticatedProtectedPackingListsIdShareRouteImport.update({
    id: '/packing-lists/$id/share',
    path: '/packing-lists/$id/share',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdIndexRoute =
  AuthenticatedProtectedTripsIdIndexRouteImport.update({
    id: '/trips/$id/',
    path: '/trips/$id/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdAttachmentsRoute =
  AuthenticatedProtectedTripsIdAttachmentsRouteImport.update({
    id: '/trips/$id/attachments',
    path: '/trips/$id/attachments',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdDetailsRoute =
  AuthenticatedProtectedTripsIdDetailsRouteImport.update({
    id: '/trips/$id/details',
    path: '/trips/$id/details',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEditRoute =
  AuthenticatedProtectedTripsIdEditRouteImport.update({
    id: '/trips/$id/edit',
    path: '/trips/$id/edit',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdExportRoute =
  AuthenticatedProtectedTripsIdExportRouteImport.update({
    id: '/trips/$id/export',
    path: '/trips/$id/export',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdImportActivityRoute =
  AuthenticatedProtectedTripsIdImportActivityRouteImport.update({
    id: '/trips/$id/import-activity',
    path: '/trips/$id/import-activity',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdRoutesRoute =
  AuthenticatedProtectedTripsIdRoutesRouteImport.update({
    id: '/trips/$id/routes',
    path: '/trips/$id/routes',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdSearchRoute =
  AuthenticatedProtectedTripsIdSearchRouteImport.update({
    id: '/trips/$id/search',
    path: '/trips/$id/search',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdSummaryRoute =
  AuthenticatedProtectedTripsIdSummaryRouteImport.update({
    id: '/trips/$id/summary',
    path: '/trips/$id/summary',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdTravellersRoute =
  AuthenticatedProtectedTripsIdTravellersRouteImport.update({
    id: '/trips/$id/travellers',
    path: '/trips/$id/travellers',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute =
  AuthenticatedProtectedAdminAdminEmailTemplatesIndexRouteImport.update({
    id: '/email-templates/',
    path: '/email-templates/',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute =
  AuthenticatedProtectedAdminAdminEmailTemplatesKeyRouteImport.update({
    id: '/email-templates/$key',
    path: '/email-templates/$key',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminUsersIndexRoute =
  AuthenticatedProtectedAdminAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminUsersNewRoute =
  AuthenticatedProtectedAdminAdminUsersNewRouteImport.update({
    id: '/users/new',
    path: '/users/new',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIdBagsNewRoute =
  AuthenticatedProtectedPackingListsIdBagsNewRouteImport.update({
    id: '/packing-lists/$id/bags/new',
    path: '/packing-lists/$id/bags/new',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdCostsCostIdRoute =
  AuthenticatedProtectedTripsIdCostsCostIdRouteImport.update({
    id: '/trips/$id/costs/$costId',
    path: '/trips/$id/costs/$costId',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdCostsAddRoute =
  AuthenticatedProtectedTripsIdCostsAddRouteImport.update({
    id: '/trips/$id/costs/add',
    path: '/trips/$id/costs/add',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdFolderIndexRoute =
  AuthenticatedProtectedTripsIdFolderIndexRouteImport.update({
    id: '/trips/$id/folder/',
    path: '/trips/$id/folder/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdFolderPickRoute =
  AuthenticatedProtectedTripsIdFolderPickRouteImport.update({
    id: '/trips/$id/folder/pick',
    path: '/trips/$id/folder/pick',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminUsersIdIndexRoute =
  AuthenticatedProtectedAdminAdminUsersIdIndexRouteImport.update({
    id: '/users/$id/',
    path: '/users/$id/',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedAdminAdminUsersIdEditRoute =
  AuthenticatedProtectedAdminAdminUsersIdEditRouteImport.update({
    id: '/users/$id/edit',
    path: '/users/$id/edit',
    getParentRoute: () => AuthenticatedProtectedAdminAdminRouteRoute,
  } as any)
const AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute =
  AuthenticatedProtectedPackingListsIdBagsBagIdEditRouteImport.update({
    id: '/packing-lists/$id/bags/$bagId/edit',
    path: '/packing-lists/$id/bags/$bagId/edit',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEventsEventIdIndexRoute =
  AuthenticatedProtectedTripsIdEventsEventIdIndexRouteImport.update({
    id: '/trips/$id/events/$eventId/',
    path: '/trips/$id/events/$eventId/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEventsEventIdCostsRoute =
  AuthenticatedProtectedTripsIdEventsEventIdCostsRouteImport.update({
    id: '/trips/$id/events/$eventId/costs',
    path: '/trips/$id/events/$eventId/costs',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEventsEventIdEditRoute =
  AuthenticatedProtectedTripsIdEventsEventIdEditRouteImport.update({
    id: '/trips/$id/events/$eventId/edit',
    path: '/trips/$id/events/$eventId/edit',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEventsEventIdInfoRoute =
  AuthenticatedProtectedTripsIdEventsEventIdInfoRouteImport.update({
    id: '/trips/$id/events/$eventId/info',
    path: '/trips/$id/events/$eventId/info',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEventsAddIndexRoute =
  AuthenticatedProtectedTripsIdEventsAddIndexRouteImport.update({
    id: '/trips/$id/events/add/',
    path: '/trips/$id/events/add/',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)
const AuthenticatedProtectedTripsIdEventsAddManualRoute =
  AuthenticatedProtectedTripsIdEventsAddManualRouteImport.update({
    id: '/trips/$id/events/add/manual',
    path: '/trips/$id/events/add/manual',
    getParentRoute: () => AuthenticatedProtectedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedProtectedIndexRoute
  '/attributions': typeof AttributionsRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/mobile-apps': typeof MobileAppsRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/banned': typeof AuthenticatedBannedRoute
  '/locked': typeof AuthenticatedLockedRoute
  '/pending-deletion': typeof AuthenticatedPendingDeletionRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/resume': typeof OauthResumeRoute
  '/t/$publicShareId': typeof TPublicShareIdRoute
  '/about': typeof AuthenticatedProtectedAboutRoute
  '/biometric-setup': typeof AuthenticatedProtectedBiometricSetupRoute
  '/copyright': typeof AuthenticatedProtectedCopyrightRoute
  '/countries': typeof AuthenticatedProtectedCountriesRoute
  '/country-covers': typeof AuthenticatedProtectedCountryCoversRoute
  '/currency-exchange': typeof AuthenticatedProtectedCurrencyExchangeRoute
  '/delete-account': typeof AuthenticatedProtectedDeleteAccountRoute
  '/design-system': typeof AuthenticatedProtectedDesignSystemRoute
  '/developer': typeof AuthenticatedProtectedDeveloperRoute
  '/forgot-password': typeof AuthenticatedProtectedForgotPasswordRoute
  '/image-credits': typeof AuthenticatedProtectedImageCreditsRoute
  '/import-email-help': typeof AuthenticatedProtectedImportEmailHelpRoute
  '/legal': typeof AuthenticatedProtectedLegalRoute
  '/map': typeof AuthenticatedProtectedMapRoute
  '/more': typeof AuthenticatedProtectedMoreRoute
  '/notifications': typeof AuthenticatedProtectedNotificationsRoute
  '/onboarding': typeof AuthenticatedProtectedOnboardingRoute
  '/open-source': typeof AuthenticatedProtectedOpenSourceRoute
  '/paywall': typeof AuthenticatedProtectedPaywallRoute
  '/plans': typeof AuthenticatedProtectedPlansRoute
  '/profile': typeof AuthenticatedProtectedProfileRoute
  '/resources': typeof AuthenticatedProtectedResourcesRoute
  '/search': typeof AuthenticatedProtectedSearchRoute
  '/share-intent': typeof AuthenticatedProtectedShareIntentRoute
  '/statistics': typeof AuthenticatedProtectedStatisticsRoute
  '/support': typeof AuthenticatedProtectedSupportRoute
  '/translate': typeof AuthenticatedProtectedTranslateRoute
  '/travel-bucket-list': typeof AuthenticatedProtectedTravelBucketListRoute
  '/usage': typeof AuthenticatedProtectedUsageRoute
  '/welcome': typeof AuthenticatedProtectedWelcomeRoute
  '/packing-lists/shared/$token': typeof PackingListsSharedTokenRoute
  '/trips/invitations/respond': typeof TripsInvitationsRespondRoute
  '/admin': typeof AuthenticatedProtectedAdminAdminRouteRouteWithChildren
  '/country/$id': typeof AuthenticatedProtectedCountryIdRoute
  '/drive/connected': typeof AuthenticatedProtectedDriveConnectedRoute
  '/packing-lists/new': typeof AuthenticatedProtectedPackingListsNewRoute
  '/settings/connections': typeof AuthenticatedProtectedSettingsConnectionsRoute
  '/settings/password': typeof AuthenticatedProtectedSettingsPasswordRoute
  '/settings/permissions': typeof AuthenticatedProtectedSettingsPermissionsRoute
  '/settings/plans': typeof AuthenticatedProtectedSettingsPlansRoute
  '/settings/subscription': typeof AuthenticatedProtectedSettingsSubscriptionRoute
  '/trip/$tripId': typeof AuthenticatedProtectedTripTripIdRoute
  '/trips/new': typeof AuthenticatedProtectedTripsNewRoute
  '/users/$userId': typeof AuthenticatedProtectedUsersUserIdRoute
  '/packing-lists/': typeof AuthenticatedProtectedPackingListsIndexRoute
  '/settings/': typeof AuthenticatedProtectedSettingsIndexRoute
  '/trips/': typeof AuthenticatedProtectedTripsIndexRoute
  '/admin/app-store-links': typeof AuthenticatedProtectedAdminAdminAppStoreLinksRoute
  '/admin/attributions': typeof AuthenticatedProtectedAdminAdminAttributionsRoute
  '/admin/authentication': typeof AuthenticatedProtectedAdminAdminAuthenticationRoute
  '/admin/general': typeof AuthenticatedProtectedAdminAdminGeneralRoute
  '/admin/jobs': typeof AuthenticatedProtectedAdminAdminJobsRoute
  '/admin/legal': typeof AuthenticatedProtectedAdminAdminLegalRoute
  '/admin/messages': typeof AuthenticatedProtectedAdminAdminMessagesRoute
  '/admin/plans': typeof AuthenticatedProtectedAdminAdminPlansRoute
  '/admin/queues': typeof AuthenticatedProtectedAdminAdminQueuesRoute
  '/packing-lists/$id/edit': typeof AuthenticatedProtectedPackingListsIdEditRoute
  '/packing-lists/$id/info': typeof AuthenticatedProtectedPackingListsIdInfoRoute
  '/packing-lists/$id/share': typeof AuthenticatedProtectedPackingListsIdShareRoute
  '/trips/$id/attachments': typeof AuthenticatedProtectedTripsIdAttachmentsRoute
  '/trips/$id/details': typeof AuthenticatedProtectedTripsIdDetailsRoute
  '/trips/$id/edit': typeof AuthenticatedProtectedTripsIdEditRoute
  '/trips/$id/export': typeof AuthenticatedProtectedTripsIdExportRoute
  '/trips/$id/import-activity': typeof AuthenticatedProtectedTripsIdImportActivityRoute
  '/trips/$id/routes': typeof AuthenticatedProtectedTripsIdRoutesRoute
  '/trips/$id/search': typeof AuthenticatedProtectedTripsIdSearchRoute
  '/trips/$id/summary': typeof AuthenticatedProtectedTripsIdSummaryRoute
  '/trips/$id/travellers': typeof AuthenticatedProtectedTripsIdTravellersRoute
  '/packing-lists/$id/': typeof AuthenticatedProtectedPackingListsIdIndexRoute
  '/trips/$id/': typeof AuthenticatedProtectedTripsIdIndexRoute
  '/admin/email-templates/$key': typeof AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute
  '/admin/users/new': typeof AuthenticatedProtectedAdminAdminUsersNewRoute
  '/packing-lists/$id/bags/new': typeof AuthenticatedProtectedPackingListsIdBagsNewRoute
  '/trips/$id/costs/$costId': typeof AuthenticatedProtectedTripsIdCostsCostIdRoute
  '/trips/$id/costs/add': typeof AuthenticatedProtectedTripsIdCostsAddRoute
  '/trips/$id/folder/pick': typeof AuthenticatedProtectedTripsIdFolderPickRoute
  '/admin/email-templates/': typeof AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute
  '/admin/users/': typeof AuthenticatedProtectedAdminAdminUsersIndexRoute
  '/trips/$id/folder/': typeof AuthenticatedProtectedTripsIdFolderIndexRoute
  '/admin/users/$id/edit': typeof AuthenticatedProtectedAdminAdminUsersIdEditRoute
  '/packing-lists/$id/bags/$bagId/edit': typeof AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute
  '/trips/$id/events/$eventId/costs': typeof AuthenticatedProtectedTripsIdEventsEventIdCostsRoute
  '/trips/$id/events/$eventId/edit': typeof AuthenticatedProtectedTripsIdEventsEventIdEditRoute
  '/trips/$id/events/$eventId/info': typeof AuthenticatedProtectedTripsIdEventsEventIdInfoRoute
  '/trips/$id/events/add/manual': typeof AuthenticatedProtectedTripsIdEventsAddManualRoute
  '/admin/users/$id/': typeof AuthenticatedProtectedAdminAdminUsersIdIndexRoute
  '/trips/$id/events/$eventId/': typeof AuthenticatedProtectedTripsIdEventsEventIdIndexRoute
  '/trips/$id/events/add/': typeof AuthenticatedProtectedTripsIdEventsAddIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedProtectedIndexRoute
  '/attributions': typeof AttributionsRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/mobile-apps': typeof MobileAppsRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/banned': typeof AuthenticatedBannedRoute
  '/locked': typeof AuthenticatedLockedRoute
  '/pending-deletion': typeof AuthenticatedPendingDeletionRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/resume': typeof OauthResumeRoute
  '/t/$publicShareId': typeof TPublicShareIdRoute
  '/about': typeof AuthenticatedProtectedAboutRoute
  '/biometric-setup': typeof AuthenticatedProtectedBiometricSetupRoute
  '/copyright': typeof AuthenticatedProtectedCopyrightRoute
  '/countries': typeof AuthenticatedProtectedCountriesRoute
  '/country-covers': typeof AuthenticatedProtectedCountryCoversRoute
  '/currency-exchange': typeof AuthenticatedProtectedCurrencyExchangeRoute
  '/delete-account': typeof AuthenticatedProtectedDeleteAccountRoute
  '/design-system': typeof AuthenticatedProtectedDesignSystemRoute
  '/developer': typeof AuthenticatedProtectedDeveloperRoute
  '/forgot-password': typeof AuthenticatedProtectedForgotPasswordRoute
  '/image-credits': typeof AuthenticatedProtectedImageCreditsRoute
  '/import-email-help': typeof AuthenticatedProtectedImportEmailHelpRoute
  '/legal': typeof AuthenticatedProtectedLegalRoute
  '/map': typeof AuthenticatedProtectedMapRoute
  '/more': typeof AuthenticatedProtectedMoreRoute
  '/notifications': typeof AuthenticatedProtectedNotificationsRoute
  '/onboarding': typeof AuthenticatedProtectedOnboardingRoute
  '/open-source': typeof AuthenticatedProtectedOpenSourceRoute
  '/paywall': typeof AuthenticatedProtectedPaywallRoute
  '/plans': typeof AuthenticatedProtectedPlansRoute
  '/profile': typeof AuthenticatedProtectedProfileRoute
  '/resources': typeof AuthenticatedProtectedResourcesRoute
  '/search': typeof AuthenticatedProtectedSearchRoute
  '/share-intent': typeof AuthenticatedProtectedShareIntentRoute
  '/statistics': typeof AuthenticatedProtectedStatisticsRoute
  '/support': typeof AuthenticatedProtectedSupportRoute
  '/translate': typeof AuthenticatedProtectedTranslateRoute
  '/travel-bucket-list': typeof AuthenticatedProtectedTravelBucketListRoute
  '/usage': typeof AuthenticatedProtectedUsageRoute
  '/welcome': typeof AuthenticatedProtectedWelcomeRoute
  '/packing-lists/shared/$token': typeof PackingListsSharedTokenRoute
  '/trips/invitations/respond': typeof TripsInvitationsRespondRoute
  '/admin': typeof AuthenticatedProtectedAdminAdminRouteRouteWithChildren
  '/country/$id': typeof AuthenticatedProtectedCountryIdRoute
  '/drive/connected': typeof AuthenticatedProtectedDriveConnectedRoute
  '/packing-lists/new': typeof AuthenticatedProtectedPackingListsNewRoute
  '/settings/connections': typeof AuthenticatedProtectedSettingsConnectionsRoute
  '/settings/password': typeof AuthenticatedProtectedSettingsPasswordRoute
  '/settings/permissions': typeof AuthenticatedProtectedSettingsPermissionsRoute
  '/settings/plans': typeof AuthenticatedProtectedSettingsPlansRoute
  '/settings/subscription': typeof AuthenticatedProtectedSettingsSubscriptionRoute
  '/trip/$tripId': typeof AuthenticatedProtectedTripTripIdRoute
  '/trips/new': typeof AuthenticatedProtectedTripsNewRoute
  '/users/$userId': typeof AuthenticatedProtectedUsersUserIdRoute
  '/packing-lists': typeof AuthenticatedProtectedPackingListsIndexRoute
  '/settings': typeof AuthenticatedProtectedSettingsIndexRoute
  '/trips': typeof AuthenticatedProtectedTripsIndexRoute
  '/admin/app-store-links': typeof AuthenticatedProtectedAdminAdminAppStoreLinksRoute
  '/admin/attributions': typeof AuthenticatedProtectedAdminAdminAttributionsRoute
  '/admin/authentication': typeof AuthenticatedProtectedAdminAdminAuthenticationRoute
  '/admin/general': typeof AuthenticatedProtectedAdminAdminGeneralRoute
  '/admin/jobs': typeof AuthenticatedProtectedAdminAdminJobsRoute
  '/admin/legal': typeof AuthenticatedProtectedAdminAdminLegalRoute
  '/admin/messages': typeof AuthenticatedProtectedAdminAdminMessagesRoute
  '/admin/plans': typeof AuthenticatedProtectedAdminAdminPlansRoute
  '/admin/queues': typeof AuthenticatedProtectedAdminAdminQueuesRoute
  '/packing-lists/$id/edit': typeof AuthenticatedProtectedPackingListsIdEditRoute
  '/packing-lists/$id/info': typeof AuthenticatedProtectedPackingListsIdInfoRoute
  '/packing-lists/$id/share': typeof AuthenticatedProtectedPackingListsIdShareRoute
  '/trips/$id/attachments': typeof AuthenticatedProtectedTripsIdAttachmentsRoute
  '/trips/$id/details': typeof AuthenticatedProtectedTripsIdDetailsRoute
  '/trips/$id/edit': typeof AuthenticatedProtectedTripsIdEditRoute
  '/trips/$id/export': typeof AuthenticatedProtectedTripsIdExportRoute
  '/trips/$id/import-activity': typeof AuthenticatedProtectedTripsIdImportActivityRoute
  '/trips/$id/routes': typeof AuthenticatedProtectedTripsIdRoutesRoute
  '/trips/$id/search': typeof AuthenticatedProtectedTripsIdSearchRoute
  '/trips/$id/summary': typeof AuthenticatedProtectedTripsIdSummaryRoute
  '/trips/$id/travellers': typeof AuthenticatedProtectedTripsIdTravellersRoute
  '/packing-lists/$id': typeof AuthenticatedProtectedPackingListsIdIndexRoute
  '/trips/$id': typeof AuthenticatedProtectedTripsIdIndexRoute
  '/admin/email-templates/$key': typeof AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute
  '/admin/users/new': typeof AuthenticatedProtectedAdminAdminUsersNewRoute
  '/packing-lists/$id/bags/new': typeof AuthenticatedProtectedPackingListsIdBagsNewRoute
  '/trips/$id/costs/$costId': typeof AuthenticatedProtectedTripsIdCostsCostIdRoute
  '/trips/$id/costs/add': typeof AuthenticatedProtectedTripsIdCostsAddRoute
  '/trips/$id/folder/pick': typeof AuthenticatedProtectedTripsIdFolderPickRoute
  '/admin/email-templates': typeof AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute
  '/admin/users': typeof AuthenticatedProtectedAdminAdminUsersIndexRoute
  '/trips/$id/folder': typeof AuthenticatedProtectedTripsIdFolderIndexRoute
  '/admin/users/$id/edit': typeof AuthenticatedProtectedAdminAdminUsersIdEditRoute
  '/packing-lists/$id/bags/$bagId/edit': typeof AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute
  '/trips/$id/events/$eventId/costs': typeof AuthenticatedProtectedTripsIdEventsEventIdCostsRoute
  '/trips/$id/events/$eventId/edit': typeof AuthenticatedProtectedTripsIdEventsEventIdEditRoute
  '/trips/$id/events/$eventId/info': typeof AuthenticatedProtectedTripsIdEventsEventIdInfoRoute
  '/trips/$id/events/add/manual': typeof AuthenticatedProtectedTripsIdEventsAddManualRoute
  '/admin/users/$id': typeof AuthenticatedProtectedAdminAdminUsersIdIndexRoute
  '/trips/$id/events/$eventId': typeof AuthenticatedProtectedTripsIdEventsEventIdIndexRoute
  '/trips/$id/events/add': typeof AuthenticatedProtectedTripsIdEventsAddIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/attributions': typeof AttributionsRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/mobile-apps': typeof MobileAppsRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/terms': typeof TermsRoute
  '/_authenticated/_protected': typeof AuthenticatedProtectedRouteRouteWithChildren
  '/_authenticated/banned': typeof AuthenticatedBannedRoute
  '/_authenticated/locked': typeof AuthenticatedLockedRoute
  '/_authenticated/pending-deletion': typeof AuthenticatedPendingDeletionRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/resume': typeof OauthResumeRoute
  '/t/$publicShareId': typeof TPublicShareIdRoute
  '/_authenticated/_protected/_admin': typeof AuthenticatedProtectedAdminRouteRouteWithChildren
  '/_authenticated/_protected/about': typeof AuthenticatedProtectedAboutRoute
  '/_authenticated/_protected/biometric-setup': typeof AuthenticatedProtectedBiometricSetupRoute
  '/_authenticated/_protected/copyright': typeof AuthenticatedProtectedCopyrightRoute
  '/_authenticated/_protected/countries': typeof AuthenticatedProtectedCountriesRoute
  '/_authenticated/_protected/country-covers': typeof AuthenticatedProtectedCountryCoversRoute
  '/_authenticated/_protected/currency-exchange': typeof AuthenticatedProtectedCurrencyExchangeRoute
  '/_authenticated/_protected/delete-account': typeof AuthenticatedProtectedDeleteAccountRoute
  '/_authenticated/_protected/design-system': typeof AuthenticatedProtectedDesignSystemRoute
  '/_authenticated/_protected/developer': typeof AuthenticatedProtectedDeveloperRoute
  '/_authenticated/_protected/forgot-password': typeof AuthenticatedProtectedForgotPasswordRoute
  '/_authenticated/_protected/image-credits': typeof AuthenticatedProtectedImageCreditsRoute
  '/_authenticated/_protected/import-email-help': typeof AuthenticatedProtectedImportEmailHelpRoute
  '/_authenticated/_protected/legal': typeof AuthenticatedProtectedLegalRoute
  '/_authenticated/_protected/map': typeof AuthenticatedProtectedMapRoute
  '/_authenticated/_protected/more': typeof AuthenticatedProtectedMoreRoute
  '/_authenticated/_protected/notifications': typeof AuthenticatedProtectedNotificationsRoute
  '/_authenticated/_protected/onboarding': typeof AuthenticatedProtectedOnboardingRoute
  '/_authenticated/_protected/open-source': typeof AuthenticatedProtectedOpenSourceRoute
  '/_authenticated/_protected/paywall': typeof AuthenticatedProtectedPaywallRoute
  '/_authenticated/_protected/plans': typeof AuthenticatedProtectedPlansRoute
  '/_authenticated/_protected/profile': typeof AuthenticatedProtectedProfileRoute
  '/_authenticated/_protected/resources': typeof AuthenticatedProtectedResourcesRoute
  '/_authenticated/_protected/search': typeof AuthenticatedProtectedSearchRoute
  '/_authenticated/_protected/share-intent': typeof AuthenticatedProtectedShareIntentRoute
  '/_authenticated/_protected/statistics': typeof AuthenticatedProtectedStatisticsRoute
  '/_authenticated/_protected/support': typeof AuthenticatedProtectedSupportRoute
  '/_authenticated/_protected/translate': typeof AuthenticatedProtectedTranslateRoute
  '/_authenticated/_protected/travel-bucket-list': typeof AuthenticatedProtectedTravelBucketListRoute
  '/_authenticated/_protected/usage': typeof AuthenticatedProtectedUsageRoute
  '/_authenticated/_protected/welcome': typeof AuthenticatedProtectedWelcomeRoute
  '/packing-lists/shared/$token': typeof PackingListsSharedTokenRoute
  '/trips/invitations/respond': typeof TripsInvitationsRespondRoute
  '/_authenticated/_protected/': typeof AuthenticatedProtectedIndexRoute
  '/_authenticated/_protected/_admin/admin': typeof AuthenticatedProtectedAdminAdminRouteRouteWithChildren
  '/_authenticated/_protected/country/$id': typeof AuthenticatedProtectedCountryIdRoute
  '/_authenticated/_protected/drive/connected': typeof AuthenticatedProtectedDriveConnectedRoute
  '/_authenticated/_protected/packing-lists/new': typeof AuthenticatedProtectedPackingListsNewRoute
  '/_authenticated/_protected/settings/connections': typeof AuthenticatedProtectedSettingsConnectionsRoute
  '/_authenticated/_protected/settings/password': typeof AuthenticatedProtectedSettingsPasswordRoute
  '/_authenticated/_protected/settings/permissions': typeof AuthenticatedProtectedSettingsPermissionsRoute
  '/_authenticated/_protected/settings/plans': typeof AuthenticatedProtectedSettingsPlansRoute
  '/_authenticated/_protected/settings/subscription': typeof AuthenticatedProtectedSettingsSubscriptionRoute
  '/_authenticated/_protected/trip/$tripId': typeof AuthenticatedProtectedTripTripIdRoute
  '/_authenticated/_protected/trips/new': typeof AuthenticatedProtectedTripsNewRoute
  '/_authenticated/_protected/users/$userId': typeof AuthenticatedProtectedUsersUserIdRoute
  '/_authenticated/_protected/packing-lists/': typeof AuthenticatedProtectedPackingListsIndexRoute
  '/_authenticated/_protected/settings/': typeof AuthenticatedProtectedSettingsIndexRoute
  '/_authenticated/_protected/trips/': typeof AuthenticatedProtectedTripsIndexRoute
  '/_authenticated/_protected/_admin/admin/app-store-links': typeof AuthenticatedProtectedAdminAdminAppStoreLinksRoute
  '/_authenticated/_protected/_admin/admin/attributions': typeof AuthenticatedProtectedAdminAdminAttributionsRoute
  '/_authenticated/_protected/_admin/admin/authentication': typeof AuthenticatedProtectedAdminAdminAuthenticationRoute
  '/_authenticated/_protected/_admin/admin/general': typeof AuthenticatedProtectedAdminAdminGeneralRoute
  '/_authenticated/_protected/_admin/admin/jobs': typeof AuthenticatedProtectedAdminAdminJobsRoute
  '/_authenticated/_protected/_admin/admin/legal': typeof AuthenticatedProtectedAdminAdminLegalRoute
  '/_authenticated/_protected/_admin/admin/messages': typeof AuthenticatedProtectedAdminAdminMessagesRoute
  '/_authenticated/_protected/_admin/admin/plans': typeof AuthenticatedProtectedAdminAdminPlansRoute
  '/_authenticated/_protected/_admin/admin/queues': typeof AuthenticatedProtectedAdminAdminQueuesRoute
  '/_authenticated/_protected/packing-lists/$id/edit': typeof AuthenticatedProtectedPackingListsIdEditRoute
  '/_authenticated/_protected/packing-lists/$id/info': typeof AuthenticatedProtectedPackingListsIdInfoRoute
  '/_authenticated/_protected/packing-lists/$id/share': typeof AuthenticatedProtectedPackingListsIdShareRoute
  '/_authenticated/_protected/trips/$id/attachments': typeof AuthenticatedProtectedTripsIdAttachmentsRoute
  '/_authenticated/_protected/trips/$id/details': typeof AuthenticatedProtectedTripsIdDetailsRoute
  '/_authenticated/_protected/trips/$id/edit': typeof AuthenticatedProtectedTripsIdEditRoute
  '/_authenticated/_protected/trips/$id/export': typeof AuthenticatedProtectedTripsIdExportRoute
  '/_authenticated/_protected/trips/$id/import-activity': typeof AuthenticatedProtectedTripsIdImportActivityRoute
  '/_authenticated/_protected/trips/$id/routes': typeof AuthenticatedProtectedTripsIdRoutesRoute
  '/_authenticated/_protected/trips/$id/search': typeof AuthenticatedProtectedTripsIdSearchRoute
  '/_authenticated/_protected/trips/$id/summary': typeof AuthenticatedProtectedTripsIdSummaryRoute
  '/_authenticated/_protected/trips/$id/travellers': typeof AuthenticatedProtectedTripsIdTravellersRoute
  '/_authenticated/_protected/packing-lists/$id/': typeof AuthenticatedProtectedPackingListsIdIndexRoute
  '/_authenticated/_protected/trips/$id/': typeof AuthenticatedProtectedTripsIdIndexRoute
  '/_authenticated/_protected/_admin/admin/email-templates/$key': typeof AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute
  '/_authenticated/_protected/_admin/admin/users/new': typeof AuthenticatedProtectedAdminAdminUsersNewRoute
  '/_authenticated/_protected/packing-lists/$id/bags/new': typeof AuthenticatedProtectedPackingListsIdBagsNewRoute
  '/_authenticated/_protected/trips/$id/costs/$costId': typeof AuthenticatedProtectedTripsIdCostsCostIdRoute
  '/_authenticated/_protected/trips/$id/costs/add': typeof AuthenticatedProtectedTripsIdCostsAddRoute
  '/_authenticated/_protected/trips/$id/folder/pick': typeof AuthenticatedProtectedTripsIdFolderPickRoute
  '/_authenticated/_protected/_admin/admin/email-templates/': typeof AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute
  '/_authenticated/_protected/_admin/admin/users/': typeof AuthenticatedProtectedAdminAdminUsersIndexRoute
  '/_authenticated/_protected/trips/$id/folder/': typeof AuthenticatedProtectedTripsIdFolderIndexRoute
  '/_authenticated/_protected/_admin/admin/users/$id/edit': typeof AuthenticatedProtectedAdminAdminUsersIdEditRoute
  '/_authenticated/_protected/packing-lists/$id/bags/$bagId/edit': typeof AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute
  '/_authenticated/_protected/trips/$id/events/$eventId/costs': typeof AuthenticatedProtectedTripsIdEventsEventIdCostsRoute
  '/_authenticated/_protected/trips/$id/events/$eventId/edit': typeof AuthenticatedProtectedTripsIdEventsEventIdEditRoute
  '/_authenticated/_protected/trips/$id/events/$eventId/info': typeof AuthenticatedProtectedTripsIdEventsEventIdInfoRoute
  '/_authenticated/_protected/trips/$id/events/add/manual': typeof AuthenticatedProtectedTripsIdEventsAddManualRoute
  '/_authenticated/_protected/_admin/admin/users/$id/': typeof AuthenticatedProtectedAdminAdminUsersIdIndexRoute
  '/_authenticated/_protected/trips/$id/events/$eventId/': typeof AuthenticatedProtectedTripsIdEventsEventIdIndexRoute
  '/_authenticated/_protected/trips/$id/events/add/': typeof AuthenticatedProtectedTripsIdEventsAddIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/attributions'
    | '/login'
    | '/mcp'
    | '/mobile-apps'
    | '/privacy'
    | '/sign-in'
    | '/sign-up'
    | '/terms'
    | '/banned'
    | '/locked'
    | '/pending-deletion'
    | '/auth/error'
    | '/auth/forgot-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/verify-email'
    | '/oauth/consent'
    | '/oauth/resume'
    | '/t/$publicShareId'
    | '/about'
    | '/biometric-setup'
    | '/copyright'
    | '/countries'
    | '/country-covers'
    | '/currency-exchange'
    | '/delete-account'
    | '/design-system'
    | '/developer'
    | '/forgot-password'
    | '/image-credits'
    | '/import-email-help'
    | '/legal'
    | '/map'
    | '/more'
    | '/notifications'
    | '/onboarding'
    | '/open-source'
    | '/paywall'
    | '/plans'
    | '/profile'
    | '/resources'
    | '/search'
    | '/share-intent'
    | '/statistics'
    | '/support'
    | '/translate'
    | '/travel-bucket-list'
    | '/usage'
    | '/welcome'
    | '/packing-lists/shared/$token'
    | '/trips/invitations/respond'
    | '/admin'
    | '/country/$id'
    | '/drive/connected'
    | '/packing-lists/new'
    | '/settings/connections'
    | '/settings/password'
    | '/settings/permissions'
    | '/settings/plans'
    | '/settings/subscription'
    | '/trip/$tripId'
    | '/trips/new'
    | '/users/$userId'
    | '/packing-lists/'
    | '/settings/'
    | '/trips/'
    | '/admin/app-store-links'
    | '/admin/attributions'
    | '/admin/authentication'
    | '/admin/general'
    | '/admin/jobs'
    | '/admin/legal'
    | '/admin/messages'
    | '/admin/plans'
    | '/admin/queues'
    | '/packing-lists/$id/edit'
    | '/packing-lists/$id/info'
    | '/packing-lists/$id/share'
    | '/trips/$id/attachments'
    | '/trips/$id/details'
    | '/trips/$id/edit'
    | '/trips/$id/export'
    | '/trips/$id/import-activity'
    | '/trips/$id/routes'
    | '/trips/$id/search'
    | '/trips/$id/summary'
    | '/trips/$id/travellers'
    | '/packing-lists/$id/'
    | '/trips/$id/'
    | '/admin/email-templates/$key'
    | '/admin/users/new'
    | '/packing-lists/$id/bags/new'
    | '/trips/$id/costs/$costId'
    | '/trips/$id/costs/add'
    | '/trips/$id/folder/pick'
    | '/admin/email-templates/'
    | '/admin/users/'
    | '/trips/$id/folder/'
    | '/admin/users/$id/edit'
    | '/packing-lists/$id/bags/$bagId/edit'
    | '/trips/$id/events/$eventId/costs'
    | '/trips/$id/events/$eventId/edit'
    | '/trips/$id/events/$eventId/info'
    | '/trips/$id/events/add/manual'
    | '/admin/users/$id/'
    | '/trips/$id/events/$eventId/'
    | '/trips/$id/events/add/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/attributions'
    | '/login'
    | '/mcp'
    | '/mobile-apps'
    | '/privacy'
    | '/sign-in'
    | '/sign-up'
    | '/terms'
    | '/banned'
    | '/locked'
    | '/pending-deletion'
    | '/auth/error'
    | '/auth/forgot-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/verify-email'
    | '/oauth/consent'
    | '/oauth/resume'
    | '/t/$publicShareId'
    | '/about'
    | '/biometric-setup'
    | '/copyright'
    | '/countries'
    | '/country-covers'
    | '/currency-exchange'
    | '/delete-account'
    | '/design-system'
    | '/developer'
    | '/forgot-password'
    | '/image-credits'
    | '/import-email-help'
    | '/legal'
    | '/map'
    | '/more'
    | '/notifications'
    | '/onboarding'
    | '/open-source'
    | '/paywall'
    | '/plans'
    | '/profile'
    | '/resources'
    | '/search'
    | '/share-intent'
    | '/statistics'
    | '/support'
    | '/translate'
    | '/travel-bucket-list'
    | '/usage'
    | '/welcome'
    | '/packing-lists/shared/$token'
    | '/trips/invitations/respond'
    | '/admin'
    | '/country/$id'
    | '/drive/connected'
    | '/packing-lists/new'
    | '/settings/connections'
    | '/settings/password'
    | '/settings/permissions'
    | '/settings/plans'
    | '/settings/subscription'
    | '/trip/$tripId'
    | '/trips/new'
    | '/users/$userId'
    | '/packing-lists'
    | '/settings'
    | '/trips'
    | '/admin/app-store-links'
    | '/admin/attributions'
    | '/admin/authentication'
    | '/admin/general'
    | '/admin/jobs'
    | '/admin/legal'
    | '/admin/messages'
    | '/admin/plans'
    | '/admin/queues'
    | '/packing-lists/$id/edit'
    | '/packing-lists/$id/info'
    | '/packing-lists/$id/share'
    | '/trips/$id/attachments'
    | '/trips/$id/details'
    | '/trips/$id/edit'
    | '/trips/$id/export'
    | '/trips/$id/import-activity'
    | '/trips/$id/routes'
    | '/trips/$id/search'
    | '/trips/$id/summary'
    | '/trips/$id/travellers'
    | '/packing-lists/$id'
    | '/trips/$id'
    | '/admin/email-templates/$key'
    | '/admin/users/new'
    | '/packing-lists/$id/bags/new'
    | '/trips/$id/costs/$costId'
    | '/trips/$id/costs/add'
    | '/trips/$id/folder/pick'
    | '/admin/email-templates'
    | '/admin/users'
    | '/trips/$id/folder'
    | '/admin/users/$id/edit'
    | '/packing-lists/$id/bags/$bagId/edit'
    | '/trips/$id/events/$eventId/costs'
    | '/trips/$id/events/$eventId/edit'
    | '/trips/$id/events/$eventId/info'
    | '/trips/$id/events/add/manual'
    | '/admin/users/$id'
    | '/trips/$id/events/$eventId'
    | '/trips/$id/events/add'
  id:
    | '__root__'
    | '/_authenticated'
    | '/attributions'
    | '/login'
    | '/mcp'
    | '/mobile-apps'
    | '/privacy'
    | '/sign-in'
    | '/sign-up'
    | '/terms'
    | '/_authenticated/_protected'
    | '/_authenticated/banned'
    | '/_authenticated/locked'
    | '/_authenticated/pending-deletion'
    | '/auth/error'
    | '/auth/forgot-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/auth/verify-email'
    | '/oauth/consent'
    | '/oauth/resume'
    | '/t/$publicShareId'
    | '/_authenticated/_protected/_admin'
    | '/_authenticated/_protected/about'
    | '/_authenticated/_protected/biometric-setup'
    | '/_authenticated/_protected/copyright'
    | '/_authenticated/_protected/countries'
    | '/_authenticated/_protected/country-covers'
    | '/_authenticated/_protected/currency-exchange'
    | '/_authenticated/_protected/delete-account'
    | '/_authenticated/_protected/design-system'
    | '/_authenticated/_protected/developer'
    | '/_authenticated/_protected/forgot-password'
    | '/_authenticated/_protected/image-credits'
    | '/_authenticated/_protected/import-email-help'
    | '/_authenticated/_protected/legal'
    | '/_authenticated/_protected/map'
    | '/_authenticated/_protected/more'
    | '/_authenticated/_protected/notifications'
    | '/_authenticated/_protected/onboarding'
    | '/_authenticated/_protected/open-source'
    | '/_authenticated/_protected/paywall'
    | '/_authenticated/_protected/plans'
    | '/_authenticated/_protected/profile'
    | '/_authenticated/_protected/resources'
    | '/_authenticated/_protected/search'
    | '/_authenticated/_protected/share-intent'
    | '/_authenticated/_protected/statistics'
    | '/_authenticated/_protected/support'
    | '/_authenticated/_protected/translate'
    | '/_authenticated/_protected/travel-bucket-list'
    | '/_authenticated/_protected/usage'
    | '/_authenticated/_protected/welcome'
    | '/packing-lists/shared/$token'
    | '/trips/invitations/respond'
    | '/_authenticated/_protected/'
    | '/_authenticated/_protected/_admin/admin'
    | '/_authenticated/_protected/country/$id'
    | '/_authenticated/_protected/drive/connected'
    | '/_authenticated/_protected/packing-lists/new'
    | '/_authenticated/_protected/settings/connections'
    | '/_authenticated/_protected/settings/password'
    | '/_authenticated/_protected/settings/permissions'
    | '/_authenticated/_protected/settings/plans'
    | '/_authenticated/_protected/settings/subscription'
    | '/_authenticated/_protected/trip/$tripId'
    | '/_authenticated/_protected/trips/new'
    | '/_authenticated/_protected/users/$userId'
    | '/_authenticated/_protected/packing-lists/'
    | '/_authenticated/_protected/settings/'
    | '/_authenticated/_protected/trips/'
    | '/_authenticated/_protected/_admin/admin/app-store-links'
    | '/_authenticated/_protected/_admin/admin/attributions'
    | '/_authenticated/_protected/_admin/admin/authentication'
    | '/_authenticated/_protected/_admin/admin/general'
    | '/_authenticated/_protected/_admin/admin/jobs'
    | '/_authenticated/_protected/_admin/admin/legal'
    | '/_authenticated/_protected/_admin/admin/messages'
    | '/_authenticated/_protected/_admin/admin/plans'
    | '/_authenticated/_protected/_admin/admin/queues'
    | '/_authenticated/_protected/packing-lists/$id/edit'
    | '/_authenticated/_protected/packing-lists/$id/info'
    | '/_authenticated/_protected/packing-lists/$id/share'
    | '/_authenticated/_protected/trips/$id/attachments'
    | '/_authenticated/_protected/trips/$id/details'
    | '/_authenticated/_protected/trips/$id/edit'
    | '/_authenticated/_protected/trips/$id/export'
    | '/_authenticated/_protected/trips/$id/import-activity'
    | '/_authenticated/_protected/trips/$id/routes'
    | '/_authenticated/_protected/trips/$id/search'
    | '/_authenticated/_protected/trips/$id/summary'
    | '/_authenticated/_protected/trips/$id/travellers'
    | '/_authenticated/_protected/packing-lists/$id/'
    | '/_authenticated/_protected/trips/$id/'
    | '/_authenticated/_protected/_admin/admin/email-templates/$key'
    | '/_authenticated/_protected/_admin/admin/users/new'
    | '/_authenticated/_protected/packing-lists/$id/bags/new'
    | '/_authenticated/_protected/trips/$id/costs/$costId'
    | '/_authenticated/_protected/trips/$id/costs/add'
    | '/_authenticated/_protected/trips/$id/folder/pick'
    | '/_authenticated/_protected/_admin/admin/email-templates/'
    | '/_authenticated/_protected/_admin/admin/users/'
    | '/_authenticated/_protected/trips/$id/folder/'
    | '/_authenticated/_protected/_admin/admin/users/$id/edit'
    | '/_authenticated/_protected/packing-lists/$id/bags/$bagId/edit'
    | '/_authenticated/_protected/trips/$id/events/$eventId/costs'
    | '/_authenticated/_protected/trips/$id/events/$eventId/edit'
    | '/_authenticated/_protected/trips/$id/events/$eventId/info'
    | '/_authenticated/_protected/trips/$id/events/add/manual'
    | '/_authenticated/_protected/_admin/admin/users/$id/'
    | '/_authenticated/_protected/trips/$id/events/$eventId/'
    | '/_authenticated/_protected/trips/$id/events/add/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  AttributionsRoute: typeof AttributionsRoute
  LoginRoute: typeof LoginRoute
  McpRoute: typeof McpRoute
  MobileAppsRoute: typeof MobileAppsRoute
  PrivacyRoute: typeof PrivacyRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  TermsRoute: typeof TermsRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OauthResumeRoute: typeof OauthResumeRoute
  TPublicShareIdRoute: typeof TPublicShareIdRoute
  PackingListsSharedTokenRoute: typeof PackingListsSharedTokenRoute
  TripsInvitationsRespondRoute: typeof TripsInvitationsRespondRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attributions': {
      id: '/attributions'
      path: '/attributions'
      fullPath: '/attributions'
      preLoaderRoute: typeof AttributionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp': {
      id: '/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof McpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mobile-apps': {
      id: '/mobile-apps'
      path: '/mobile-apps'
      fullPath: '/mobile-apps'
      preLoaderRoute: typeof MobileAppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_protected': {
      id: '/_authenticated/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedProtectedRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/banned': {
      id: '/_authenticated/banned'
      path: '/banned'
      fullPath: '/banned'
      preLoaderRoute: typeof AuthenticatedBannedRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/locked': {
      id: '/_authenticated/locked'
      path: '/locked'
      fullPath: '/locked'
      preLoaderRoute: typeof AuthenticatedLockedRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pending-deletion': {
      id: '/_authenticated/pending-deletion'
      path: '/pending-deletion'
      fullPath: '/pending-deletion'
      preLoaderRoute: typeof AuthenticatedPendingDeletionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/auth/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/resume': {
      id: '/oauth/resume'
      path: '/oauth/resume'
      fullPath: '/oauth/resume'
      preLoaderRoute: typeof OauthResumeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$publicShareId': {
      id: '/t/$publicShareId'
      path: '/t/$publicShareId'
      fullPath: '/t/$publicShareId'
      preLoaderRoute: typeof TPublicShareIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_protected/': {
      id: '/_authenticated/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedProtectedIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/_admin': {
      id: '/_authenticated/_protected/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedProtectedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/about': {
      id: '/_authenticated/_protected/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthenticatedProtectedAboutRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/biometric-setup': {
      id: '/_authenticated/_protected/biometric-setup'
      path: '/biometric-setup'
      fullPath: '/biometric-setup'
      preLoaderRoute: typeof AuthenticatedProtectedBiometricSetupRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/copyright': {
      id: '/_authenticated/_protected/copyright'
      path: '/copyright'
      fullPath: '/copyright'
      preLoaderRoute: typeof AuthenticatedProtectedCopyrightRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/countries': {
      id: '/_authenticated/_protected/countries'
      path: '/countries'
      fullPath: '/countries'
      preLoaderRoute: typeof AuthenticatedProtectedCountriesRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/country-covers': {
      id: '/_authenticated/_protected/country-covers'
      path: '/country-covers'
      fullPath: '/country-covers'
      preLoaderRoute: typeof AuthenticatedProtectedCountryCoversRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/currency-exchange': {
      id: '/_authenticated/_protected/currency-exchange'
      path: '/currency-exchange'
      fullPath: '/currency-exchange'
      preLoaderRoute: typeof AuthenticatedProtectedCurrencyExchangeRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/delete-account': {
      id: '/_authenticated/_protected/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof AuthenticatedProtectedDeleteAccountRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/design-system': {
      id: '/_authenticated/_protected/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AuthenticatedProtectedDesignSystemRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/developer': {
      id: '/_authenticated/_protected/developer'
      path: '/developer'
      fullPath: '/developer'
      preLoaderRoute: typeof AuthenticatedProtectedDeveloperRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/forgot-password': {
      id: '/_authenticated/_protected/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthenticatedProtectedForgotPasswordRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/image-credits': {
      id: '/_authenticated/_protected/image-credits'
      path: '/image-credits'
      fullPath: '/image-credits'
      preLoaderRoute: typeof AuthenticatedProtectedImageCreditsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/import-email-help': {
      id: '/_authenticated/_protected/import-email-help'
      path: '/import-email-help'
      fullPath: '/import-email-help'
      preLoaderRoute: typeof AuthenticatedProtectedImportEmailHelpRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/legal': {
      id: '/_authenticated/_protected/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof AuthenticatedProtectedLegalRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/map': {
      id: '/_authenticated/_protected/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof AuthenticatedProtectedMapRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/more': {
      id: '/_authenticated/_protected/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AuthenticatedProtectedMoreRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/notifications': {
      id: '/_authenticated/_protected/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedProtectedNotificationsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/onboarding': {
      id: '/_authenticated/_protected/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedProtectedOnboardingRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/open-source': {
      id: '/_authenticated/_protected/open-source'
      path: '/open-source'
      fullPath: '/open-source'
      preLoaderRoute: typeof AuthenticatedProtectedOpenSourceRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/paywall': {
      id: '/_authenticated/_protected/paywall'
      path: '/paywall'
      fullPath: '/paywall'
      preLoaderRoute: typeof AuthenticatedProtectedPaywallRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/plans': {
      id: '/_authenticated/_protected/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthenticatedProtectedPlansRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/profile': {
      id: '/_authenticated/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProtectedProfileRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/resources': {
      id: '/_authenticated/_protected/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthenticatedProtectedResourcesRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/search': {
      id: '/_authenticated/_protected/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedProtectedSearchRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/share-intent': {
      id: '/_authenticated/_protected/share-intent'
      path: '/share-intent'
      fullPath: '/share-intent'
      preLoaderRoute: typeof AuthenticatedProtectedShareIntentRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/statistics': {
      id: '/_authenticated/_protected/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AuthenticatedProtectedStatisticsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/support': {
      id: '/_authenticated/_protected/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedProtectedSupportRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/translate': {
      id: '/_authenticated/_protected/translate'
      path: '/translate'
      fullPath: '/translate'
      preLoaderRoute: typeof AuthenticatedProtectedTranslateRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/travel-bucket-list': {
      id: '/_authenticated/_protected/travel-bucket-list'
      path: '/travel-bucket-list'
      fullPath: '/travel-bucket-list'
      preLoaderRoute: typeof AuthenticatedProtectedTravelBucketListRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/usage': {
      id: '/_authenticated/_protected/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof AuthenticatedProtectedUsageRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/welcome': {
      id: '/_authenticated/_protected/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedProtectedWelcomeRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/packing-lists/shared/$token': {
      id: '/packing-lists/shared/$token'
      path: '/packing-lists/shared/$token'
      fullPath: '/packing-lists/shared/$token'
      preLoaderRoute: typeof PackingListsSharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trips/invitations/respond': {
      id: '/trips/invitations/respond'
      path: '/trips/invitations/respond'
      fullPath: '/trips/invitations/respond'
      preLoaderRoute: typeof TripsInvitationsRespondRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_protected/_admin/admin': {
      id: '/_authenticated/_protected/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminRouteRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminRouteRoute
    }
    '/_authenticated/_protected/country/$id': {
      id: '/_authenticated/_protected/country/$id'
      path: '/country/$id'
      fullPath: '/country/$id'
      preLoaderRoute: typeof AuthenticatedProtectedCountryIdRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/drive/connected': {
      id: '/_authenticated/_protected/drive/connected'
      path: '/drive/connected'
      fullPath: '/drive/connected'
      preLoaderRoute: typeof AuthenticatedProtectedDriveConnectedRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/packing-lists/': {
      id: '/_authenticated/_protected/packing-lists/'
      path: '/packing-lists'
      fullPath: '/packing-lists/'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/packing-lists/new': {
      id: '/_authenticated/_protected/packing-lists/new'
      path: '/packing-lists/new'
      fullPath: '/packing-lists/new'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsNewRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/settings/': {
      id: '/_authenticated/_protected/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedProtectedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/settings/connections': {
      id: '/_authenticated/_protected/settings/connections'
      path: '/settings/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AuthenticatedProtectedSettingsConnectionsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/settings/password': {
      id: '/_authenticated/_protected/settings/password'
      path: '/settings/password'
      fullPath: '/settings/password'
      preLoaderRoute: typeof AuthenticatedProtectedSettingsPasswordRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/settings/permissions': {
      id: '/_authenticated/_protected/settings/permissions'
      path: '/settings/permissions'
      fullPath: '/settings/permissions'
      preLoaderRoute: typeof AuthenticatedProtectedSettingsPermissionsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/settings/plans': {
      id: '/_authenticated/_protected/settings/plans'
      path: '/settings/plans'
      fullPath: '/settings/plans'
      preLoaderRoute: typeof AuthenticatedProtectedSettingsPlansRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/settings/subscription': {
      id: '/_authenticated/_protected/settings/subscription'
      path: '/settings/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof AuthenticatedProtectedSettingsSubscriptionRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trip/$tripId': {
      id: '/_authenticated/_protected/trip/$tripId'
      path: '/trip/$tripId'
      fullPath: '/trip/$tripId'
      preLoaderRoute: typeof AuthenticatedProtectedTripTripIdRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/': {
      id: '/_authenticated/_protected/trips/'
      path: '/trips'
      fullPath: '/trips/'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/new': {
      id: '/_authenticated/_protected/trips/new'
      path: '/trips/new'
      fullPath: '/trips/new'
      preLoaderRoute: typeof AuthenticatedProtectedTripsNewRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/users/$userId': {
      id: '/_authenticated/_protected/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedProtectedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/app-store-links': {
      id: '/_authenticated/_protected/_admin/admin/app-store-links'
      path: '/app-store-links'
      fullPath: '/admin/app-store-links'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminAppStoreLinksRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/attributions': {
      id: '/_authenticated/_protected/_admin/admin/attributions'
      path: '/attributions'
      fullPath: '/admin/attributions'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminAttributionsRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/authentication': {
      id: '/_authenticated/_protected/_admin/admin/authentication'
      path: '/authentication'
      fullPath: '/admin/authentication'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminAuthenticationRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/general': {
      id: '/_authenticated/_protected/_admin/admin/general'
      path: '/general'
      fullPath: '/admin/general'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminGeneralRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/jobs': {
      id: '/_authenticated/_protected/_admin/admin/jobs'
      path: '/jobs'
      fullPath: '/admin/jobs'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminJobsRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/legal': {
      id: '/_authenticated/_protected/_admin/admin/legal'
      path: '/legal'
      fullPath: '/admin/legal'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminLegalRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/messages': {
      id: '/_authenticated/_protected/_admin/admin/messages'
      path: '/messages'
      fullPath: '/admin/messages'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminMessagesRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/plans': {
      id: '/_authenticated/_protected/_admin/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminPlansRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/queues': {
      id: '/_authenticated/_protected/_admin/admin/queues'
      path: '/queues'
      fullPath: '/admin/queues'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminQueuesRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/packing-lists/$id/': {
      id: '/_authenticated/_protected/packing-lists/$id/'
      path: '/packing-lists/$id'
      fullPath: '/packing-lists/$id/'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIdIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/packing-lists/$id/edit': {
      id: '/_authenticated/_protected/packing-lists/$id/edit'
      path: '/packing-lists/$id/edit'
      fullPath: '/packing-lists/$id/edit'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIdEditRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/packing-lists/$id/info': {
      id: '/_authenticated/_protected/packing-lists/$id/info'
      path: '/packing-lists/$id/info'
      fullPath: '/packing-lists/$id/info'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIdInfoRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/packing-lists/$id/share': {
      id: '/_authenticated/_protected/packing-lists/$id/share'
      path: '/packing-lists/$id/share'
      fullPath: '/packing-lists/$id/share'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIdShareRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/': {
      id: '/_authenticated/_protected/trips/$id/'
      path: '/trips/$id'
      fullPath: '/trips/$id/'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/attachments': {
      id: '/_authenticated/_protected/trips/$id/attachments'
      path: '/trips/$id/attachments'
      fullPath: '/trips/$id/attachments'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdAttachmentsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/details': {
      id: '/_authenticated/_protected/trips/$id/details'
      path: '/trips/$id/details'
      fullPath: '/trips/$id/details'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdDetailsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/edit': {
      id: '/_authenticated/_protected/trips/$id/edit'
      path: '/trips/$id/edit'
      fullPath: '/trips/$id/edit'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEditRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/export': {
      id: '/_authenticated/_protected/trips/$id/export'
      path: '/trips/$id/export'
      fullPath: '/trips/$id/export'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdExportRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/import-activity': {
      id: '/_authenticated/_protected/trips/$id/import-activity'
      path: '/trips/$id/import-activity'
      fullPath: '/trips/$id/import-activity'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdImportActivityRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/routes': {
      id: '/_authenticated/_protected/trips/$id/routes'
      path: '/trips/$id/routes'
      fullPath: '/trips/$id/routes'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdRoutesRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/search': {
      id: '/_authenticated/_protected/trips/$id/search'
      path: '/trips/$id/search'
      fullPath: '/trips/$id/search'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdSearchRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/summary': {
      id: '/_authenticated/_protected/trips/$id/summary'
      path: '/trips/$id/summary'
      fullPath: '/trips/$id/summary'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdSummaryRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/travellers': {
      id: '/_authenticated/_protected/trips/$id/travellers'
      path: '/trips/$id/travellers'
      fullPath: '/trips/$id/travellers'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdTravellersRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/email-templates/': {
      id: '/_authenticated/_protected/_admin/admin/email-templates/'
      path: '/email-templates'
      fullPath: '/admin/email-templates/'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminEmailTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/email-templates/$key': {
      id: '/_authenticated/_protected/_admin/admin/email-templates/$key'
      path: '/email-templates/$key'
      fullPath: '/admin/email-templates/$key'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminEmailTemplatesKeyRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/users/': {
      id: '/_authenticated/_protected/_admin/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/users/new': {
      id: '/_authenticated/_protected/_admin/admin/users/new'
      path: '/users/new'
      fullPath: '/admin/users/new'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminUsersNewRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/packing-lists/$id/bags/new': {
      id: '/_authenticated/_protected/packing-lists/$id/bags/new'
      path: '/packing-lists/$id/bags/new'
      fullPath: '/packing-lists/$id/bags/new'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIdBagsNewRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/costs/$costId': {
      id: '/_authenticated/_protected/trips/$id/costs/$costId'
      path: '/trips/$id/costs/$costId'
      fullPath: '/trips/$id/costs/$costId'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdCostsCostIdRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/costs/add': {
      id: '/_authenticated/_protected/trips/$id/costs/add'
      path: '/trips/$id/costs/add'
      fullPath: '/trips/$id/costs/add'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdCostsAddRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/folder/': {
      id: '/_authenticated/_protected/trips/$id/folder/'
      path: '/trips/$id/folder'
      fullPath: '/trips/$id/folder/'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdFolderIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/folder/pick': {
      id: '/_authenticated/_protected/trips/$id/folder/pick'
      path: '/trips/$id/folder/pick'
      fullPath: '/trips/$id/folder/pick'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdFolderPickRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/users/$id/': {
      id: '/_authenticated/_protected/_admin/admin/users/$id/'
      path: '/users/$id'
      fullPath: '/admin/users/$id/'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminUsersIdIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/_admin/admin/users/$id/edit': {
      id: '/_authenticated/_protected/_admin/admin/users/$id/edit'
      path: '/users/$id/edit'
      fullPath: '/admin/users/$id/edit'
      preLoaderRoute: typeof AuthenticatedProtectedAdminAdminUsersIdEditRouteImport
      parentRoute: typeof AuthenticatedProtectedAdminAdminRouteRoute
    }
    '/_authenticated/_protected/packing-lists/$id/bags/$bagId/edit': {
      id: '/_authenticated/_protected/packing-lists/$id/bags/$bagId/edit'
      path: '/packing-lists/$id/bags/$bagId/edit'
      fullPath: '/packing-lists/$id/bags/$bagId/edit'
      preLoaderRoute: typeof AuthenticatedProtectedPackingListsIdBagsBagIdEditRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/events/$eventId/': {
      id: '/_authenticated/_protected/trips/$id/events/$eventId/'
      path: '/trips/$id/events/$eventId'
      fullPath: '/trips/$id/events/$eventId/'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/events/$eventId/costs': {
      id: '/_authenticated/_protected/trips/$id/events/$eventId/costs'
      path: '/trips/$id/events/$eventId/costs'
      fullPath: '/trips/$id/events/$eventId/costs'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdCostsRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/events/$eventId/edit': {
      id: '/_authenticated/_protected/trips/$id/events/$eventId/edit'
      path: '/trips/$id/events/$eventId/edit'
      fullPath: '/trips/$id/events/$eventId/edit'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdEditRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/events/$eventId/info': {
      id: '/_authenticated/_protected/trips/$id/events/$eventId/info'
      path: '/trips/$id/events/$eventId/info'
      fullPath: '/trips/$id/events/$eventId/info'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdInfoRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/events/add/': {
      id: '/_authenticated/_protected/trips/$id/events/add/'
      path: '/trips/$id/events/add'
      fullPath: '/trips/$id/events/add/'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEventsAddIndexRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
    '/_authenticated/_protected/trips/$id/events/add/manual': {
      id: '/_authenticated/_protected/trips/$id/events/add/manual'
      path: '/trips/$id/events/add/manual'
      fullPath: '/trips/$id/events/add/manual'
      preLoaderRoute: typeof AuthenticatedProtectedTripsIdEventsAddManualRouteImport
      parentRoute: typeof AuthenticatedProtectedRouteRoute
    }
  }
}

interface AuthenticatedProtectedAdminAdminRouteRouteChildren {
  AuthenticatedProtectedAdminAdminAppStoreLinksRoute: typeof AuthenticatedProtectedAdminAdminAppStoreLinksRoute
  AuthenticatedProtectedAdminAdminAttributionsRoute: typeof AuthenticatedProtectedAdminAdminAttributionsRoute
  AuthenticatedProtectedAdminAdminAuthenticationRoute: typeof AuthenticatedProtectedAdminAdminAuthenticationRoute
  AuthenticatedProtectedAdminAdminGeneralRoute: typeof AuthenticatedProtectedAdminAdminGeneralRoute
  AuthenticatedProtectedAdminAdminJobsRoute: typeof AuthenticatedProtectedAdminAdminJobsRoute
  AuthenticatedProtectedAdminAdminLegalRoute: typeof AuthenticatedProtectedAdminAdminLegalRoute
  AuthenticatedProtectedAdminAdminMessagesRoute: typeof AuthenticatedProtectedAdminAdminMessagesRoute
  AuthenticatedProtectedAdminAdminPlansRoute: typeof AuthenticatedProtectedAdminAdminPlansRoute
  AuthenticatedProtectedAdminAdminQueuesRoute: typeof AuthenticatedProtectedAdminAdminQueuesRoute
  AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute: typeof AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute
  AuthenticatedProtectedAdminAdminUsersNewRoute: typeof AuthenticatedProtectedAdminAdminUsersNewRoute
  AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute: typeof AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute
  AuthenticatedProtectedAdminAdminUsersIndexRoute: typeof AuthenticatedProtectedAdminAdminUsersIndexRoute
  AuthenticatedProtectedAdminAdminUsersIdEditRoute: typeof AuthenticatedProtectedAdminAdminUsersIdEditRoute
  AuthenticatedProtectedAdminAdminUsersIdIndexRoute: typeof AuthenticatedProtectedAdminAdminUsersIdIndexRoute
}

const AuthenticatedProtectedAdminAdminRouteRouteChildren: AuthenticatedProtectedAdminAdminRouteRouteChildren =
  {
    AuthenticatedProtectedAdminAdminAppStoreLinksRoute:
      AuthenticatedProtectedAdminAdminAppStoreLinksRoute,
    AuthenticatedProtectedAdminAdminAttributionsRoute:
      AuthenticatedProtectedAdminAdminAttributionsRoute,
    AuthenticatedProtectedAdminAdminAuthenticationRoute:
      AuthenticatedProtectedAdminAdminAuthenticationRoute,
    AuthenticatedProtectedAdminAdminGeneralRoute:
      AuthenticatedProtectedAdminAdminGeneralRoute,
    AuthenticatedProtectedAdminAdminJobsRoute:
      AuthenticatedProtectedAdminAdminJobsRoute,
    AuthenticatedProtectedAdminAdminLegalRoute:
      AuthenticatedProtectedAdminAdminLegalRoute,
    AuthenticatedProtectedAdminAdminMessagesRoute:
      AuthenticatedProtectedAdminAdminMessagesRoute,
    AuthenticatedProtectedAdminAdminPlansRoute:
      AuthenticatedProtectedAdminAdminPlansRoute,
    AuthenticatedProtectedAdminAdminQueuesRoute:
      AuthenticatedProtectedAdminAdminQueuesRoute,
    AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute:
      AuthenticatedProtectedAdminAdminEmailTemplatesKeyRoute,
    AuthenticatedProtectedAdminAdminUsersNewRoute:
      AuthenticatedProtectedAdminAdminUsersNewRoute,
    AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute:
      AuthenticatedProtectedAdminAdminEmailTemplatesIndexRoute,
    AuthenticatedProtectedAdminAdminUsersIndexRoute:
      AuthenticatedProtectedAdminAdminUsersIndexRoute,
    AuthenticatedProtectedAdminAdminUsersIdEditRoute:
      AuthenticatedProtectedAdminAdminUsersIdEditRoute,
    AuthenticatedProtectedAdminAdminUsersIdIndexRoute:
      AuthenticatedProtectedAdminAdminUsersIdIndexRoute,
  }

const AuthenticatedProtectedAdminAdminRouteRouteWithChildren =
  AuthenticatedProtectedAdminAdminRouteRoute._addFileChildren(
    AuthenticatedProtectedAdminAdminRouteRouteChildren,
  )

interface AuthenticatedProtectedAdminRouteRouteChildren {
  AuthenticatedProtectedAdminAdminRouteRoute: typeof AuthenticatedProtectedAdminAdminRouteRouteWithChildren
}

const AuthenticatedProtectedAdminRouteRouteChildren: AuthenticatedProtectedAdminRouteRouteChildren =
  {
    AuthenticatedProtectedAdminAdminRouteRoute:
      AuthenticatedProtectedAdminAdminRouteRouteWithChildren,
  }

const AuthenticatedProtectedAdminRouteRouteWithChildren =
  AuthenticatedProtectedAdminRouteRoute._addFileChildren(
    AuthenticatedProtectedAdminRouteRouteChildren,
  )

interface AuthenticatedProtectedRouteRouteChildren {
  AuthenticatedProtectedAdminRouteRoute: typeof AuthenticatedProtectedAdminRouteRouteWithChildren
  AuthenticatedProtectedAboutRoute: typeof AuthenticatedProtectedAboutRoute
  AuthenticatedProtectedBiometricSetupRoute: typeof AuthenticatedProtectedBiometricSetupRoute
  AuthenticatedProtectedCopyrightRoute: typeof AuthenticatedProtectedCopyrightRoute
  AuthenticatedProtectedCountriesRoute: typeof AuthenticatedProtectedCountriesRoute
  AuthenticatedProtectedCountryCoversRoute: typeof AuthenticatedProtectedCountryCoversRoute
  AuthenticatedProtectedCurrencyExchangeRoute: typeof AuthenticatedProtectedCurrencyExchangeRoute
  AuthenticatedProtectedDeleteAccountRoute: typeof AuthenticatedProtectedDeleteAccountRoute
  AuthenticatedProtectedDesignSystemRoute: typeof AuthenticatedProtectedDesignSystemRoute
  AuthenticatedProtectedDeveloperRoute: typeof AuthenticatedProtectedDeveloperRoute
  AuthenticatedProtectedForgotPasswordRoute: typeof AuthenticatedProtectedForgotPasswordRoute
  AuthenticatedProtectedImageCreditsRoute: typeof AuthenticatedProtectedImageCreditsRoute
  AuthenticatedProtectedImportEmailHelpRoute: typeof AuthenticatedProtectedImportEmailHelpRoute
  AuthenticatedProtectedLegalRoute: typeof AuthenticatedProtectedLegalRoute
  AuthenticatedProtectedMapRoute: typeof AuthenticatedProtectedMapRoute
  AuthenticatedProtectedMoreRoute: typeof AuthenticatedProtectedMoreRoute
  AuthenticatedProtectedNotificationsRoute: typeof AuthenticatedProtectedNotificationsRoute
  AuthenticatedProtectedOnboardingRoute: typeof AuthenticatedProtectedOnboardingRoute
  AuthenticatedProtectedOpenSourceRoute: typeof AuthenticatedProtectedOpenSourceRoute
  AuthenticatedProtectedPaywallRoute: typeof AuthenticatedProtectedPaywallRoute
  AuthenticatedProtectedPlansRoute: typeof AuthenticatedProtectedPlansRoute
  AuthenticatedProtectedProfileRoute: typeof AuthenticatedProtectedProfileRoute
  AuthenticatedProtectedResourcesRoute: typeof AuthenticatedProtectedResourcesRoute
  AuthenticatedProtectedSearchRoute: typeof AuthenticatedProtectedSearchRoute
  AuthenticatedProtectedShareIntentRoute: typeof AuthenticatedProtectedShareIntentRoute
  AuthenticatedProtectedStatisticsRoute: typeof AuthenticatedProtectedStatisticsRoute
  AuthenticatedProtectedSupportRoute: typeof AuthenticatedProtectedSupportRoute
  AuthenticatedProtectedTranslateRoute: typeof AuthenticatedProtectedTranslateRoute
  AuthenticatedProtectedTravelBucketListRoute: typeof AuthenticatedProtectedTravelBucketListRoute
  AuthenticatedProtectedUsageRoute: typeof AuthenticatedProtectedUsageRoute
  AuthenticatedProtectedWelcomeRoute: typeof AuthenticatedProtectedWelcomeRoute
  AuthenticatedProtectedIndexRoute: typeof AuthenticatedProtectedIndexRoute
  AuthenticatedProtectedCountryIdRoute: typeof AuthenticatedProtectedCountryIdRoute
  AuthenticatedProtectedDriveConnectedRoute: typeof AuthenticatedProtectedDriveConnectedRoute
  AuthenticatedProtectedPackingListsNewRoute: typeof AuthenticatedProtectedPackingListsNewRoute
  AuthenticatedProtectedSettingsConnectionsRoute: typeof AuthenticatedProtectedSettingsConnectionsRoute
  AuthenticatedProtectedSettingsPasswordRoute: typeof AuthenticatedProtectedSettingsPasswordRoute
  AuthenticatedProtectedSettingsPermissionsRoute: typeof AuthenticatedProtectedSettingsPermissionsRoute
  AuthenticatedProtectedSettingsPlansRoute: typeof AuthenticatedProtectedSettingsPlansRoute
  AuthenticatedProtectedSettingsSubscriptionRoute: typeof AuthenticatedProtectedSettingsSubscriptionRoute
  AuthenticatedProtectedTripTripIdRoute: typeof AuthenticatedProtectedTripTripIdRoute
  AuthenticatedProtectedTripsNewRoute: typeof AuthenticatedProtectedTripsNewRoute
  AuthenticatedProtectedUsersUserIdRoute: typeof AuthenticatedProtectedUsersUserIdRoute
  AuthenticatedProtectedPackingListsIndexRoute: typeof AuthenticatedProtectedPackingListsIndexRoute
  AuthenticatedProtectedSettingsIndexRoute: typeof AuthenticatedProtectedSettingsIndexRoute
  AuthenticatedProtectedTripsIndexRoute: typeof AuthenticatedProtectedTripsIndexRoute
  AuthenticatedProtectedPackingListsIdEditRoute: typeof AuthenticatedProtectedPackingListsIdEditRoute
  AuthenticatedProtectedPackingListsIdInfoRoute: typeof AuthenticatedProtectedPackingListsIdInfoRoute
  AuthenticatedProtectedPackingListsIdShareRoute: typeof AuthenticatedProtectedPackingListsIdShareRoute
  AuthenticatedProtectedTripsIdAttachmentsRoute: typeof AuthenticatedProtectedTripsIdAttachmentsRoute
  AuthenticatedProtectedTripsIdDetailsRoute: typeof AuthenticatedProtectedTripsIdDetailsRoute
  AuthenticatedProtectedTripsIdEditRoute: typeof AuthenticatedProtectedTripsIdEditRoute
  AuthenticatedProtectedTripsIdExportRoute: typeof AuthenticatedProtectedTripsIdExportRoute
  AuthenticatedProtectedTripsIdImportActivityRoute: typeof AuthenticatedProtectedTripsIdImportActivityRoute
  AuthenticatedProtectedTripsIdRoutesRoute: typeof AuthenticatedProtectedTripsIdRoutesRoute
  AuthenticatedProtectedTripsIdSearchRoute: typeof AuthenticatedProtectedTripsIdSearchRoute
  AuthenticatedProtectedTripsIdSummaryRoute: typeof AuthenticatedProtectedTripsIdSummaryRoute
  AuthenticatedProtectedTripsIdTravellersRoute: typeof AuthenticatedProtectedTripsIdTravellersRoute
  AuthenticatedProtectedPackingListsIdIndexRoute: typeof AuthenticatedProtectedPackingListsIdIndexRoute
  AuthenticatedProtectedTripsIdIndexRoute: typeof AuthenticatedProtectedTripsIdIndexRoute
  AuthenticatedProtectedPackingListsIdBagsNewRoute: typeof AuthenticatedProtectedPackingListsIdBagsNewRoute
  AuthenticatedProtectedTripsIdCostsCostIdRoute: typeof AuthenticatedProtectedTripsIdCostsCostIdRoute
  AuthenticatedProtectedTripsIdCostsAddRoute: typeof AuthenticatedProtectedTripsIdCostsAddRoute
  AuthenticatedProtectedTripsIdFolderPickRoute: typeof AuthenticatedProtectedTripsIdFolderPickRoute
  AuthenticatedProtectedTripsIdFolderIndexRoute: typeof AuthenticatedProtectedTripsIdFolderIndexRoute
  AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute: typeof AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute
  AuthenticatedProtectedTripsIdEventsEventIdCostsRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdCostsRoute
  AuthenticatedProtectedTripsIdEventsEventIdEditRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdEditRoute
  AuthenticatedProtectedTripsIdEventsEventIdInfoRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdInfoRoute
  AuthenticatedProtectedTripsIdEventsAddManualRoute: typeof AuthenticatedProtectedTripsIdEventsAddManualRoute
  AuthenticatedProtectedTripsIdEventsEventIdIndexRoute: typeof AuthenticatedProtectedTripsIdEventsEventIdIndexRoute
  AuthenticatedProtectedTripsIdEventsAddIndexRoute: typeof AuthenticatedProtectedTripsIdEventsAddIndexRoute
}

const AuthenticatedProtectedRouteRouteChildren: AuthenticatedProtectedRouteRouteChildren =
  {
    AuthenticatedProtectedAdminRouteRoute:
      AuthenticatedProtectedAdminRouteRouteWithChildren,
    AuthenticatedProtectedAboutRoute: AuthenticatedProtectedAboutRoute,
    AuthenticatedProtectedBiometricSetupRoute:
      AuthenticatedProtectedBiometricSetupRoute,
    AuthenticatedProtectedCopyrightRoute: AuthenticatedProtectedCopyrightRoute,
    AuthenticatedProtectedCountriesRoute: AuthenticatedProtectedCountriesRoute,
    AuthenticatedProtectedCountryCoversRoute:
      AuthenticatedProtectedCountryCoversRoute,
    AuthenticatedProtectedCurrencyExchangeRoute:
      AuthenticatedProtectedCurrencyExchangeRoute,
    AuthenticatedProtectedDeleteAccountRoute:
      AuthenticatedProtectedDeleteAccountRoute,
    AuthenticatedProtectedDesignSystemRoute:
      AuthenticatedProtectedDesignSystemRoute,
    AuthenticatedProtectedDeveloperRoute: AuthenticatedProtectedDeveloperRoute,
    AuthenticatedProtectedForgotPasswordRoute:
      AuthenticatedProtectedForgotPasswordRoute,
    AuthenticatedProtectedImageCreditsRoute:
      AuthenticatedProtectedImageCreditsRoute,
    AuthenticatedProtectedImportEmailHelpRoute:
      AuthenticatedProtectedImportEmailHelpRoute,
    AuthenticatedProtectedLegalRoute: AuthenticatedProtectedLegalRoute,
    AuthenticatedProtectedMapRoute: AuthenticatedProtectedMapRoute,
    AuthenticatedProtectedMoreRoute: AuthenticatedProtectedMoreRoute,
    AuthenticatedProtectedNotificationsRoute:
      AuthenticatedProtectedNotificationsRoute,
    AuthenticatedProtectedOnboardingRoute:
      AuthenticatedProtectedOnboardingRoute,
    AuthenticatedProtectedOpenSourceRoute:
      AuthenticatedProtectedOpenSourceRoute,
    AuthenticatedProtectedPaywallRoute: AuthenticatedProtectedPaywallRoute,
    AuthenticatedProtectedPlansRoute: AuthenticatedProtectedPlansRoute,
    AuthenticatedProtectedProfileRoute: AuthenticatedProtectedProfileRoute,
    AuthenticatedProtectedResourcesRoute: AuthenticatedProtectedResourcesRoute,
    AuthenticatedProtectedSearchRoute: AuthenticatedProtectedSearchRoute,
    AuthenticatedProtectedShareIntentRoute:
      AuthenticatedProtectedShareIntentRoute,
    AuthenticatedProtectedStatisticsRoute:
      AuthenticatedProtectedStatisticsRoute,
    AuthenticatedProtectedSupportRoute: AuthenticatedProtectedSupportRoute,
    AuthenticatedProtectedTranslateRoute: AuthenticatedProtectedTranslateRoute,
    AuthenticatedProtectedTravelBucketListRoute:
      AuthenticatedProtectedTravelBucketListRoute,
    AuthenticatedProtectedUsageRoute: AuthenticatedProtectedUsageRoute,
    AuthenticatedProtectedWelcomeRoute: AuthenticatedProtectedWelcomeRoute,
    AuthenticatedProtectedIndexRoute: AuthenticatedProtectedIndexRoute,
    AuthenticatedProtectedCountryIdRoute: AuthenticatedProtectedCountryIdRoute,
    AuthenticatedProtectedDriveConnectedRoute:
      AuthenticatedProtectedDriveConnectedRoute,
    AuthenticatedProtectedPackingListsNewRoute:
      AuthenticatedProtectedPackingListsNewRoute,
    AuthenticatedProtectedSettingsConnectionsRoute:
      AuthenticatedProtectedSettingsConnectionsRoute,
    AuthenticatedProtectedSettingsPasswordRoute:
      AuthenticatedProtectedSettingsPasswordRoute,
    AuthenticatedProtectedSettingsPermissionsRoute:
      AuthenticatedProtectedSettingsPermissionsRoute,
    AuthenticatedProtectedSettingsPlansRoute:
      AuthenticatedProtectedSettingsPlansRoute,
    AuthenticatedProtectedSettingsSubscriptionRoute:
      AuthenticatedProtectedSettingsSubscriptionRoute,
    AuthenticatedProtectedTripTripIdRoute:
      AuthenticatedProtectedTripTripIdRoute,
    AuthenticatedProtectedTripsNewRoute: AuthenticatedProtectedTripsNewRoute,
    AuthenticatedProtectedUsersUserIdRoute:
      AuthenticatedProtectedUsersUserIdRoute,
    AuthenticatedProtectedPackingListsIndexRoute:
      AuthenticatedProtectedPackingListsIndexRoute,
    AuthenticatedProtectedSettingsIndexRoute:
      AuthenticatedProtectedSettingsIndexRoute,
    AuthenticatedProtectedTripsIndexRoute:
      AuthenticatedProtectedTripsIndexRoute,
    AuthenticatedProtectedPackingListsIdEditRoute:
      AuthenticatedProtectedPackingListsIdEditRoute,
    AuthenticatedProtectedPackingListsIdInfoRoute:
      AuthenticatedProtectedPackingListsIdInfoRoute,
    AuthenticatedProtectedPackingListsIdShareRoute:
      AuthenticatedProtectedPackingListsIdShareRoute,
    AuthenticatedProtectedTripsIdAttachmentsRoute:
      AuthenticatedProtectedTripsIdAttachmentsRoute,
    AuthenticatedProtectedTripsIdDetailsRoute:
      AuthenticatedProtectedTripsIdDetailsRoute,
    AuthenticatedProtectedTripsIdEditRoute:
      AuthenticatedProtectedTripsIdEditRoute,
    AuthenticatedProtectedTripsIdExportRoute:
      AuthenticatedProtectedTripsIdExportRoute,
    AuthenticatedProtectedTripsIdImportActivityRoute:
      AuthenticatedProtectedTripsIdImportActivityRoute,
    AuthenticatedProtectedTripsIdRoutesRoute:
      AuthenticatedProtectedTripsIdRoutesRoute,
    AuthenticatedProtectedTripsIdSearchRoute:
      AuthenticatedProtectedTripsIdSearchRoute,
    AuthenticatedProtectedTripsIdSummaryRoute:
      AuthenticatedProtectedTripsIdSummaryRoute,
    AuthenticatedProtectedTripsIdTravellersRoute:
      AuthenticatedProtectedTripsIdTravellersRoute,
    AuthenticatedProtectedPackingListsIdIndexRoute:
      AuthenticatedProtectedPackingListsIdIndexRoute,
    AuthenticatedProtectedTripsIdIndexRoute:
      AuthenticatedProtectedTripsIdIndexRoute,
    AuthenticatedProtectedPackingListsIdBagsNewRoute:
      AuthenticatedProtectedPackingListsIdBagsNewRoute,
    AuthenticatedProtectedTripsIdCostsCostIdRoute:
      AuthenticatedProtectedTripsIdCostsCostIdRoute,
    AuthenticatedProtectedTripsIdCostsAddRoute:
      AuthenticatedProtectedTripsIdCostsAddRoute,
    AuthenticatedProtectedTripsIdFolderPickRoute:
      AuthenticatedProtectedTripsIdFolderPickRoute,
    AuthenticatedProtectedTripsIdFolderIndexRoute:
      AuthenticatedProtectedTripsIdFolderIndexRoute,
    AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute:
      AuthenticatedProtectedPackingListsIdBagsBagIdEditRoute,
    AuthenticatedProtectedTripsIdEventsEventIdCostsRoute:
      AuthenticatedProtectedTripsIdEventsEventIdCostsRoute,
    AuthenticatedProtectedTripsIdEventsEventIdEditRoute:
      AuthenticatedProtectedTripsIdEventsEventIdEditRoute,
    AuthenticatedProtectedTripsIdEventsEventIdInfoRoute:
      AuthenticatedProtectedTripsIdEventsEventIdInfoRoute,
    AuthenticatedProtectedTripsIdEventsAddManualRoute:
      AuthenticatedProtectedTripsIdEventsAddManualRoute,
    AuthenticatedProtectedTripsIdEventsEventIdIndexRoute:
      AuthenticatedProtectedTripsIdEventsEventIdIndexRoute,
    AuthenticatedProtectedTripsIdEventsAddIndexRoute:
      AuthenticatedProtectedTripsIdEventsAddIndexRoute,
  }

const AuthenticatedProtectedRouteRouteWithChildren =
  AuthenticatedProtectedRouteRoute._addFileChildren(
    AuthenticatedProtectedRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProtectedRouteRoute: typeof AuthenticatedProtectedRouteRouteWithChildren
  AuthenticatedBannedRoute: typeof AuthenticatedBannedRoute
  AuthenticatedLockedRoute: typeof AuthenticatedLockedRoute
  AuthenticatedPendingDeletionRoute: typeof AuthenticatedPendingDeletionRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProtectedRouteRoute:
    AuthenticatedProtectedRouteRouteWithChildren,
  AuthenticatedBannedRoute: AuthenticatedBannedRoute,
  AuthenticatedLockedRoute: AuthenticatedLockedRoute,
  AuthenticatedPendingDeletionRoute: AuthenticatedPendingDeletionRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  AttributionsRoute: AttributionsRoute,
  LoginRoute: LoginRoute,
  McpRoute: McpRoute,
  MobileAppsRoute: MobileAppsRoute,
  PrivacyRoute: PrivacyRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  TermsRoute: TermsRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  OauthConsentRoute: OauthConsentRoute,
  OauthResumeRoute: OauthResumeRoute,
  TPublicShareIdRoute: TPublicShareIdRoute,
  PackingListsSharedTokenRoute: PackingListsSharedTokenRoute,
  TripsInvitationsRespondRoute: TripsInvitationsRespondRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
